
import React, { useEffect, useRef, useState } from "react";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import DescriptionIcon from '@mui/icons-material/Description';
import api from "../../api/api";
import ToastMessage from "../../utils/muitoast";
import { Backdrop, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import CloseIcon from '@mui/icons-material/Close';
import SignatureModal from "../Signaturemodal";
import UploadFileIcon from '@mui/icons-material/UploadFile';
import SafetyImageCommentModal from "./safetyimgmodal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import GlobalUploadModal from "./globalupload";
import { useSearchParams } from "react-router-dom";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
const steps = [
  "Audit Information",
  "PPE",
  "Pre-Job Planning",
  "Site Safety & Postings",
  "Work Environment & Heights",
  "Tools & Equipment Safety",
  "Excavation, Subcontractor & Action Plan",
  "Infractions & Signatures",
];

const SafetyHomeInfoForm = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [severity, setSeverity] = useState('success');
  const [open, setOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [activeSuggestionIndex, setActiveSuggestionIndex] = useState(null);

  const [showEmpSuggestions, setShowEmpSuggestions] = useState(false);
  const [employeeId, setEmployeeId] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [employeeSuggestions, setEmployeeSuggestions] = useState([]);
  
  const [selectedempobj,setselectedempobj]=useState({})
  const [pmolist,setpmolist]=useState([])
      const [searchParams] = useSearchParams();
  const [suggestions, setSuggestions] = useState([]);
    const [jobCode, setJobCode] = useState('');
    const [selectedJobName, setSelectedJobName] = useState('');
    const [companyTabs, setCompanyTabs] = useState([]); // Replaces 'Tabs'
    const [selectedCompanyId, setSelectedCompanyId] = useState(null); // To store selected company ID
    const jobInputRef = useRef(null);
    // PM list per row
const [pmByEntry, setPmByEntry] = useState({})

// employee suggestions per row
const [employeeSuggestionsByEntry, setEmployeeSuggestionsByEntry] = useState({})

    const empInputRef = useRef(null);
  const totalPages = 8;
  const [signaturemodal,setSignatureModal]=useState(false)
    const [infractionImages, setInfractionImages] = useState([]);
  const type=useRef('auditor')
  const[AuditorImage,setAuditorImg]=useState('')
  const[supervisorImage,setSupervisorImage]=useState('')
  // State to store all form data
  const { t, i18n } = useTranslation(['safetyhealth']); 
  const [selectedLanguage, setSelectedLanguage] = useState('en');
  const [hoveredJobIndex, setHoveredJobIndex] = useState(null);
const [hoveredEmpIndex, setHoveredEmpIndex] = useState(null);
  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    setSelectedLanguage(lang);
  };
const [isSafetyModalOpen, setIsSafetyModalOpen] = useState(false);
const [selectedSection, setSelectedSection] = useState(null);
const [selectedIndex, setSelectedIndex] = useState(null);
const [isGlobalUploadModalOpen, setIsGlobalUploadModalOpen] = useState(false);
  const mode = searchParams.get("mode"); // null if not sent
const id = searchParams.get("id"); 
const sectionQuestions = {
  ppe:[
              "Hard hats worn properly",
              "Safety glasses with side shields",
              "Grinding protection (V2G goggles + face shield)",
              "Safety-toed footwear",
              "FRC clothing (long sleeves/pants or coveralls)",
              "Hearing protection in designated areas",
              "Proper gloves for task",
              "Extra PPE available onsite",
              "Reflective vests for spotters",
            ],
  preJob: [
    "Daily safety meetings Conducted",
    "DJSA/CJSA completed and reviewed",
    "Task-specific hazards/controls documented",
    "Permits (Client/NTACT) in place",
    "Operations have valid training cards",
    "Monthly safety training held",
    "Site orientation completed",
  ],
  siteSafety: [
    "Emergency contacts posted",
    "First aid signage visible",
    "Labour law Posters (5-in-1, OSHA log, etc.)",
    "One Call ticket for excavation",
    "Safety alerts posted",
  ],
  workEnvironment: [
    "Smoking areas marked, with extinguisher",
    "Equipment operated by certified personnel",
    "Equipment inspections documented",
    "Equipment safely parked & attachments secured",
    "H2S monitors calibrated and worn properly",
    "First aid kits stocked, accessible",
    "Water & sanitation facilities provided",
    "Housekeeping maintained",
  ],
  workingAtHeights: [
    "Fall protection used over 6'",
    "Ladders/scaffolds inspected, secured, labeled",
    "Tools/materials secured in elevated work (Drops Program)",
    "Overhead protection to workers when overhead hazards exist",
    "Open holes marked and covered",
  ],
  toolsElectrical: [
    "GFCIs used and tested",
    "Cords protected and grounded",
    "Tools inspected, color coded",
    "Fire extinguishers available & inspected",
    "Flammable materials handled per safety protocols",
  ],
  weldingGas: [
    "Welding rig inspected",
    "Fire watch available",
    "PPE for grinding (double eye protection)",
    "Compressed gas cylinders secured and labeled",
    "Hoses in good condition and crimped",
  ],
  excavation: [
    "One Call completed",
    "Excavations barricaded & dry",
    "Access ladders/ramps every 25'",
    "Proper shoring/sloping for 5'+",
    "Utilities marked",
  ],
  subcontractor: [
    "JSA's used for tasks",
    "PPE used correctly",
    "Training cards on hand",
    "SIMOPS JSA signed when applicable",
    "Equipment and First Aid checked",
  ],
  emergencyPlan: [
    "Is the SSSP plan available and reviewed",
    "Do employees know what is in the plan",
    "Do employees know how to react to an emergency",
    "Is the emergency plan noted on JSA",
    "Is there a system for accounting everyone onsite",
  ],
};

  // Single formData state object
  const [formData, setFormData] = useState({
    companyId: null,
    emp_Id:null,
    jobNumber: '',
    // empname:'',
    method:'',
    auditorName: "",
    auditors:[ { auditorName: "", designation: "", file: "", imgurl: "" }],
     companyJobEntries: [
      {
        company: { id: null, name: "" },
        job: { job_num: "", job_name: "" },
          projectManager: { pm_id: null, pm_name: "" },
      employee: { emp_id: null, emp_name: "" }
      }
    ],
    auditDate: "",
    // location: "",
    // projectNumber: "",
    // Page 2: PPE (9 questions)
    ppe: Array(9).fill(""),
    // Page 3: Pre-Job Planning & Training (7 questions)
    preJob: Array(7).fill(""),
    // Page 4: Site Safety and Postings (5 questions)
    siteSafety: Array(5).fill(""),
    // Page 5: Work Environment (8 questions) & Working at Heights (5 questions)
    workEnvironment: Array(8).fill(""),
    workingAtHeights: Array(5).fill(""),
    // Page 6: Tools, Electrical & Fire Safety (5 questions) & Welding & Compressed Gas Safety (5 questions)
    toolsElectrical: Array(5).fill(""),
    weldingGas: Array(5).fill(""),
    // Page 7: Excavation Safety (5 questions), Subcontractor Safety (5 questions), Emergency Action Plan (5 questions)
    excavation: Array(5).fill(""),
    subcontractor: Array(5).fill(""),
    emergencyPlan: Array(5).fill(""),
    // Page 8: Infractions
    infractions: [
      {
        section: "",
        item: "",
        correctiveAction: "",
        completed: "",
        action: "",
        photo:{}
      },
    ],
    // Page 8: Signatures
    // auditorSignature: "",
    // supervisorSignature: "",
    signatureDate: "",
  });

  const handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  // Handler for Audit Information and Signature fields
  const handleInputChange = (e, section, field) => {
    const { value } = e.target;
    if (section) {
      setFormData(prev => ({
        ...prev,
        [section]: {
          ...prev[section],
          [field]: value
        }
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [field]: value
      }));
    }
  };
  // Add new company-job entry
const addCompanyJobEntry = () => {
  setFormData((prev) => ({
    ...prev,
    companyJobEntries: [
      ...prev.companyJobEntries,
      {
        company: { id: null, name: "" },
        job: { job_num: "", job_name: "" }
      }
    ]
  }));
};
// Update PM entry
const updatePMEntry = (index, pmObj) => {
  setFormData((prev) => {
    const updatedEntries = [...prev.companyJobEntries];
    updatedEntries[index] = {
      ...updatedEntries[index],
      projectManager: pmObj
    };
    return { ...prev, companyJobEntries: updatedEntries };
  });
  
  // Sync first entry with main formData fields
  if (index === 0) {
    setFormData((prev) => ({
      ...prev,
      pm_id: pmObj.pm_id,
      pm_name: pmObj.pm_name
    }));
  }
};

// Update Employee entry
const updateEmployeeEntry = (index, empObj) => {
  setFormData((prev) => {
    const updatedEntries = [...prev.companyJobEntries];
    updatedEntries[index] = {
      ...updatedEntries[index],
      employee: empObj
    };
    return { ...prev, companyJobEntries: updatedEntries };
  });
  
  // Sync first entry with main formData fields
  if (index === 0) {
    setFormData((prev) => ({
      ...prev,
      emp_Id: empObj.emp_id,
      auditorName: empObj.emp_name
    }));
  }
};
// Remove company-job entry
const removeCompanyJobEntry = (index) => {
  if (index === 0) return; // Don't allow removing first entry
  
  setFormData((prev) => {
    const updatedEntries = prev.companyJobEntries.filter((_, i) => i !== index);
    return { ...prev, companyJobEntries: updatedEntries };
  });
};

// Update company entry
const updateCompanyEntry = (index, companyObj) => {
  setFormData((prev) => {
    const updatedEntries = [...prev.companyJobEntries];
    updatedEntries[index] = {
      ...updatedEntries[index],
      company: companyObj
    };
    return { ...prev, companyJobEntries: updatedEntries };
  });
  
  // Sync first entry with main formData fields
  if (index === 0) {
    setFormData((prev) => ({
      ...prev,
      companyId: companyObj.id
    }));
  }
};

// Update job entry
const updateJobEntry = (index, jobObj) => {
  setFormData((prev) => {
    const updatedEntries = [...prev.companyJobEntries];
    updatedEntries[index] = {
      ...updatedEntries[index],
      job: jobObj
    };
    return { ...prev, companyJobEntries: updatedEntries };
  });
  
  // Sync first entry with main formData fields
  if (index === 0) {
    setFormData((prev) => ({
      ...prev,
      jobNumber: jobObj.job_num
    }));
  }
};

// Handle company selection
const handleCompanyJobSelect = (index, companyId, companyName) => {
  updateCompanyEntry(index, { id: companyId, name: companyName });

  if (!companyId) return;

  // fetch PM for THIS row
  fetchpm(companyId).then((res) => {
    setPmByEntry(prev => ({
      ...prev,
      [index]: res
    }));
  });
};

// Handler for Radio Buttons
const handleRadioChange = (section, index, value) => {
  setFormData((prev) => {
    const updated = { ...prev };
    const sectionArray = [...(updated[section] || [])];

    // Ensure consistent object structure
    sectionArray[index] = {
      ...(sectionArray[index] || {}),
      answer: value,
    };

    updated[section] = sectionArray;
    return updated;
  });

  // Open modal when "NO" is selected
  if (value === "NO") {
    setSelectedSection(section);
    setSelectedIndex(index);
    setIsSafetyModalOpen(true);
  }
};
const handleModalSubmit = async (comment, files) => {
  try {
  
    setLoader(true);

    // 🟩 Case 1: No images, only comment
    if (!files || files.length === 0) {
      setFormData((prev) => {
        const updated = { ...prev };
        if (!updated[selectedSection]) return prev;
        updated[selectedSection][selectedIndex] = {
          ...updated[selectedSection][selectedIndex],
          comment,
        };
        return updated;
      });

      setIsSafetyModalOpen(false);
      return;
    }

    // 🟦 Case 2: Images provided → create previews & upload
    const localPreviews = files.map((file) =>
      typeof file === "string" ? file : URL.createObjectURL(file)
    );

    // Prepare FormData with multiple files
    const formDataa = new FormData();
    files.forEach((file) => {
      if (file instanceof File) {
        formDataa.append("files", file);
      } else {
        // base64 string (captured from camera)
        const blob = dataURLtoBlob(file);
        formDataa.append("files", blob, "captured_image.png");
      }
    });

    // ⏳ Show previews immediately
    setFormData((prev) => {
      const updated = { ...prev };
      if (!updated[selectedSection]) return prev;
      updated[selectedSection][selectedIndex] = {
        ...updated[selectedSection][selectedIndex],
        comment,
        localpreviews: localPreviews,
      };
      return updated;
    });

    // 🧠 Upload files to server
    const response = await api.post("/v1/forms/upload-files", formDataa, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    const uploadedFiles = response?.files || [];

    // ✅ Update state with uploaded image paths
    setFormData((prev) => {
      const updated = { ...prev };
      if (!updated[selectedSection]) return prev;
      updated[selectedSection][selectedIndex] = {
        ...updated[selectedSection][selectedIndex],
        comment,
        images: uploadedFiles, // server file paths array
        localpreviews: localPreviews, // keep local previews for UI
      };
      return updated;
    });

    setIsSafetyModalOpen(false);
  } catch (error) {
    console.error("File upload failed:", error);
  } finally {
    setLoader(false);
  }
};
const mapApiToFormData = (apiData) => {
  try {
    const jsonArray = apiData.json_data || [];

    // Helper: get answer(s) by question prefix
    const getSectionAnswers = (prefix) =>
      jsonArray
        .filter((x) => x.question.startsWith(prefix))
        .map((x) => ({
          answer: x.answer,
          comment: x.comment || "",
          images: x.image || [],
          localpreviews: [],
        }));

    // 1️⃣ AUDIT INFO
    const auditorName = jsonArray.find((x) => x.question === "Auditor Name")?.answer || "";
    const auditDate = jsonArray.find((x) => x.question === "Audit Date")?.answer || "";
    const signatures = jsonArray.find((x) => x.question === "Signatures")?.answer || [];
const comment=jsonArray.find((x) => x.question === "comment")?.answer || "";
    // 2️⃣ MULTIPLE AUDITORS (DYNAMIC)
    const auditors = jsonArray.find((x) => x.question === "Auditors")?.answer || [];

    const auditorsMapped = auditors.map((a) => ({
      auditorName: a.auditorName || "",
      designation: a.designation || "",
      file: null,                     // FILE WILL BE UPLOADED IF USER REPLACES
      imgurl: a?.uploadedFile || "",  // stored server path for preview
      uploadedFile: a?.uploadedFile || "",
    }));

    // 3️⃣ INFRACTIONS
    const infractions = jsonArray.find((x) => x.question === "Infractions")?.answer || [];
    const infractionsMapped = infractions.map((inf) => ({
      section: inf.section || "",
      item: inf.item || "",
      correctiveAction: inf.correctiveAction || "",
      completed: inf.completed || "",
      action: inf.action || "",
      photo: inf.photo || {},
    }));
 // 4️⃣ MAP COMPANY-JOB ENTRIES
    const companyJobEntries = apiData.company_job_entries || [
      {
        company: {
          id: apiData.companyid || null,
          name: apiData.company_name || ""
        },
        job: {
          job_num: apiData.job_id || "",
          job_name: apiData.job_name || ""
        }
      }
    ];
    // 4️⃣ MAP ALL 8 SECTIONS
    if(apiData?.companyid){
          fetchpm(apiData?.companyid)
    }
    return {
      companyId: apiData.companyid || null,
       pm_id:apiData.pm_id||'',
       pm_name:apiData.pm_name||'',
comment:comment,
      emp_Id: apiData.emp_id || null,
      jobNumber: apiData.job_id || "",
      method: apiData.method || "",
      auditorName,
      auditors: auditorsMapped.length ? auditorsMapped : [{ auditorName: "", designation: "", file: "", imgurl: "" }],
      auditDate,
         companyJobEntries: companyJobEntries,
      ppe: getSectionAnswers("PPE -"),
      preJob: getSectionAnswers("Pre-Job Planning -"),
      siteSafety: getSectionAnswers("Site Safety -"),
      workEnvironment: getSectionAnswers("Work Environment -"),
      workingAtHeights: getSectionAnswers("Working at Heights -"),
      toolsElectrical: getSectionAnswers("Tools Electrical -"),
      weldingGas: getSectionAnswers("Welding Gas -"),
      excavation: getSectionAnswers("Excavation -"),
      subcontractor: getSectionAnswers("Subcontractor -"),
      emergencyPlan: getSectionAnswers("Emergency Plan -"),
      infractions: infractionsMapped.length
        ? infractionsMapped
        : [
            {
              section: "",
              item: "",
              correctiveAction: "",
              completed: "",
              action: "",
              photo: {},
            },
          ],
      signatureDate: jsonArray.find((x) => x.question === "Signature Date")?.answer || "",
      supervisorSignature: signatures[0] || null, // signature file path from backend
    };
  } catch (e) {
    console.error("Error in mapApiToFormData:", e);
    return null;
  }
};

const fetchcurrentformdata=async()=>{
  try {
    setLoader(true)
     const res = await api.get(`/v1/forms/get_by_id`,{
      params:{
          rowid:id
        }
      });
   if (res.status === 200) {
      const apiData = res.data[0];

      const mapped =mapApiToFormData(apiData);
console.log(mapped,'mapppeddata')
      setFormData(mapped);
    }
    
  } catch (error) {
    console.log(error)
  }finally{
setLoader(false)
  }
}

useEffect(() => {
  if (mode === "edit" && id) {
  fetchcurrentformdata()
  }
}, [mode, id]);
// ✅ Utility: Convert base64 to Blob for FormData
function dataURLtoBlob(dataURL) {
  const arr = dataURL.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}

 const fetchpm=async(id)=>{
      try {
        setLoader(true)
        const response =await api.get(`/v1/companies/${id}/project-managers`)
        if(response.status==200){
setpmolist(response?.data||[])
return response?.data||[]
        }
      } catch (error) {
        console.log(error)
      }finally{
setLoader(false)
      }
    }

// const handleModalSubmit = async (comment, file) => {
//   if (!file) return;

//   try {
//     setLoader(true);
//   // If no image, just update comment locally
//     if (!file) {
//       setFormData((prev) => {
//         const updated = { ...prev };
//         if (!updated[selectedSection]) return prev;
//         updated[selectedSection][selectedIndex] = {
//           ...updated[selectedSection][selectedIndex],
//           comment,
//         };
//         return updated;
//       });

//       setIsSafetyModalOpen(false);
//       return;
//     }
//     const formDataa = new FormData();
//     formDataa.append("files", file);
//  const localPreview = URL.createObjectURL(file);
//     const response = await api.post("/v1/forms/upload-files", formDataa, {
//       headers: { "Content-Type": "multipart/form-data" },
//     });

//     const uploadedFile = Array.isArray(response?.files)
//       ? response.files[0]
//       : response?.file || null;

//     if (uploadedFile) {
//       setFormData((prev) => {
//         const updated = { ...prev };
//         if (!updated[selectedSection]) return prev;
//         updated[selectedSection][selectedIndex] = {
//           ...updated[selectedSection][selectedIndex],
//           comment,
//           image: uploadedFile,
//           localpreview: localPreview
//         };
//         return updated;
//       });
//     }

//     setIsSafetyModalOpen(false);
//   } catch (error) {
//     console.error("File upload failed:", error);
//   } finally {
//     setLoader(false);
//   }
// };

  // Handler for Infractions
  const handleInfractionChange = (index, field, value) => {
    setFormData((prev) => {
      const updatedInfractions = [...prev.infractions];
      updatedInfractions[index] = { ...updatedInfractions[index], [field]: value };
      return { ...prev, infractions: updatedInfractions };
    });
  };
 const handleDeleteRow = (index) => {
  setFormData((prev) => {
    const updatedInfractions = [...prev.infractions];
    updatedInfractions.splice(index, 1); // remove the selected row
    return { ...prev, infractions: updatedInfractions };
  });

  // 🧹 Also remove the corresponding image preview (if stored separately)
  setInfractionImages((prev) => prev.filter((img) => img.index !== index));
};


const HandleSignature = (x) => {
  console.log("===== HandleSignature called =====");
  console.log("File received:", x?.name, x?.size);

  if (type.current === 'auditor') {
    console.log('Setting auditor image');
    setAuditorImg(x);
    console.log('Auditor image set:', x?.name, x?.size, URL.createObjectURL(x));
  } else if (typeof type.current === 'number') {
    console.log(`Updating auditor at index ${type.current}`);
    const updatedAuditors = [...formData.auditors];
    updatedAuditors[type.current] = {
      ...updatedAuditors[type.current],
      file: x,
      imgurl: URL.createObjectURL(x) // optional preview
    };
    setFormData({ ...formData, auditors: updatedAuditors });
    console.log(
      `Auditor ${type.current} updated:`,
      updatedAuditors[type.current].file?.name,
      updatedAuditors[type.current].file?.size,
      updatedAuditors[type.current].imgurl
    );
  } else {
    console.log('Setting supervisor image');
    setSupervisorImage(x);
    console.log('Supervisor image set:', x?.name, x?.size, URL.createObjectURL(x));
  }
};

  // Add new infraction
  const addInfraction = () => {
    setFormData((prev) => ({
      ...prev,
      infractions: [
        ...prev.infractions,
        {
          section: "",
          item: "",
          correctiveAction: "",
          completed: "",
          action: "",
        },
      ],
    }));
  };

  // Generate JSON data from formData
  const generateJsonData = (formData) => {
    const json = [];
  if (formData.comment) {
      json.push({
        question: "comment",
        answer: formData.comment,
      });
    }
  
    if (formData.auditorName) {
      json.push({
        question: "Auditor Name",
        answer: formData.auditorName,
      });
    }
    if (formData.auditDate) {
      json.push({
        question: "Audit Date",
        answer: formData.auditDate,
      });
    }

    if(formData?.signatures){
     
      json.push({question: "Signatures",
        answer: formData?.signatures})
    }
     if(formData?.auditors.length){
     
      json.push({question: "Auditors",
        answer: formData?.auditors})
    }
    if (formData.location) {
      json.push({
        question: "Location",
        answer: formData.location,
      });
    }
    if (formData.projectNumber) {
      json.push({
        question: "Project Number",
        answer: formData.projectNumber,
      });
    }

  // Step 2: PPE
const ppeQuestions = [
  "Hard hats worn properly",
  "Safety glasses with side shields",
  "Grinding protection (V2G goggles + face shield)",
  "Safety-toed footwear",
  "FRC clothing (long sleeves/pants or coveralls)",
  "Hearing protection in designated areas",
  "Proper gloves for task",
  "Extra PPE available onsite",
  "Reflective vests for spotters",
];

ppeQuestions.forEach((question, index) => {
  const item = formData.ppe[index];
  if (item && item.answer) {

    const obj = {
      question: `PPE - ${question}`,
      answer: item.answer,
    };

    if (item.comment) obj.comment = item.comment;
    if (item.images) obj.image = item.images;

    json.push(obj);
  }
});

// Step 3: Pre-Job Planning & Training
const preJobQuestions = [
  "Daily safety meetings Conducted",
  "DJSA/CJSA completed and reviewed",
  "Task-specific hazards/controls documented",
  "Permits (Client/NTACT) in place",
  "Operations have valid training cards",
  "Monthly safety training held",
  "Site orientation completed",
];
preJobQuestions.forEach((question, index) => {
  const item = formData.preJob[index];
  if (item && item.answer) {
        console.log(item,'ietemmm')
    const obj = {
      question: `Pre-Job Planning - ${question}`,
      answer: item.answer,
    };
    if (item.comment) obj.comment = item.comment;
    if (item.images) obj.image = item.images;
    json.push(obj);
  }
});

// Step 4: Site Safety and Postings
const siteSafetyQuestions = [
  "Emergency contacts posted",
  "First aid signage visible",
  "Labour law Posters (5-in-1, OSHA log, etc.)",
  "One Call ticket for excavation",
  "Safety alerts posted",
];
siteSafetyQuestions.forEach((question, index) => {
  const item = formData.siteSafety[index];
  if (item && item.answer) {
    const obj = {
      question: `Site Safety - ${question}`,
      answer: item.answer,
    };
    if (item.comment) obj.comment = item.comment;
    if (item.images) obj.image = item.images;
    json.push(obj);
  }
});

// Step 5: Work Environment
const workEnvironmentQuestions = [
  "Smoking areas marked, with extinguisher",
  "Equipment operated by certified personnel",
  "Equipment inspections documented",
  "Equipment safely parked & attachments secured",
  "H2S monitors calibrated and worn properly",
  "First aid kits stocked, accessible",
  "Water & sanitation facilities provided",
  "Housekeeping maintained",
];
workEnvironmentQuestions.forEach((question, index) => {
  const item = formData.workEnvironment[index];
  if (item && item.answer) {
    const obj = {
      question: `Work Environment - ${question}`,
      answer: item.answer,
    };
    if (item.comment) obj.comment = item.comment;
    if (item.images) obj.image = item.images;
    json.push(obj);
  }
});

// Step 5: Working at Heights
const workingAtHeightsQuestions = [
  "Fall protection used over 6'",
  "Ladders/scaffolds inspected, secured, labeled",
  "Tools/materials secured in elevated work (Drops Program)",
  "Overhead protection to workers when overhead hazards exist",
  "Open holes marked and covered",
];
workingAtHeightsQuestions.forEach((question, index) => {
  const item = formData.workingAtHeights[index];
  if (item && item.answer) {
    const obj = {
      question: `Working at Heights - ${question}`,
      answer: item.answer,
    };
    if (item.comment) obj.comment = item.comment;
    if (item.images) obj.image = item.images;
    json.push(obj);
  }
});

// Step 6: Tools, Electrical & Fire Safety
const toolsElectricalQuestions = [
  "GFCIs used and tested",
  "Cords protected and grounded",
  "Tools inspected, color coded",
  "Fire extinguishers available & inspected",
  "Flammable materials handled per safety protocols",
];
toolsElectricalQuestions.forEach((question, index) => {
  const item = formData.toolsElectrical[index];
  if (item && item.answer) {
    const obj = {
      question: `Tools Electrical - ${question}`,
      answer: item.answer,
    };
    if (item.comment) obj.comment = item.comment;
    if (item.images) obj.image = item.images;
    json.push(obj);
  }
});

// Step 6: Welding & Compressed Gas Safety
const weldingGasQuestions = [
  "Welding rig inspected",
  "Fire watch available",
  "PPE for grinding (double eye protection)",
  "Compressed gas cylinders secured and labeled",
  "Hoses in good condition and crimped",
];
weldingGasQuestions.forEach((question, index) => {
  const item = formData.weldingGas[index];
  if (item && item.answer) {
    const obj = {
      question: `Welding Gas - ${question}`,
      answer: item.answer,
    };
    if (item.comment) obj.comment = item.comment;
    if (item.images) obj.image = item.images;
    json.push(obj);
  }
});

// Step 7: Excavation Safety
const excavationQuestions = [
  "One Call completed",
  "Excavations barricaded & dry",
  "Access ladders/ramps every 25'",
  "Proper shoring/sloping for 5'+",
  "Utilities marked",
];
excavationQuestions.forEach((question, index) => {
  const item = formData.excavation[index];
  if (item && item.answer) {
    const obj = {
      question: `Excavation - ${question}`,
      answer: item.answer,
    };
    if (item.comment) obj.comment = item.comment;
    if (item.images) obj.image = item.images;
    json.push(obj);
  }
});

// Step 7: Subcontractor Safety
const subcontractorQuestions = [
  "JSA's used for tasks",
  "PPE used correctly",
  "Training cards on hand",
  "SIMOPS JSA signed when applicable",
  "Equipment and First Aid checked",
];
subcontractorQuestions.forEach((question, index) => {
  const item = formData.subcontractor[index];
  if (item && item.answer) {
    const obj = {
      question: `Subcontractor - ${question}`,
      answer: item.answer,
    };
    if (item.comment) obj.comment = item.comment;
    if (item.images) obj.image = item.images;
    json.push(obj);
  }
});

// Step 7: Emergency Action Plan
const emergencyPlanQuestions = [
  "Is the SSSP plan available and reviewed",
  "Do employees know what is in the plan",
  "Do employees know how to react to an emergency",
  "Is the emergency plan noted on JSA",
  "Is there a system for accounting everyone onsite",
];
emergencyPlanQuestions.forEach((question, index) => {
  const item = formData.emergencyPlan[index];
  if (item && item.answer) {
    const obj = {
      question: `Emergency Plan - ${question}`,
      answer: item.answer,
    };
    if (item.comment) obj.comment = item.comment;
    if (item.images) obj.image = item.images;
    json.push(obj);
  }
});

    // Step 8: Infractions
    if (Array.isArray(formData.infractions) && formData.infractions.length > 0) {
      console.log(formData.infractions,'infractiondata')
      json.push({
        question: "Infractions",
        answer: formData.infractions.map((entry) => ({
          section: entry.section,
          item: entry.item,
          correctiveAction: entry.correctiveAction,
          completed: entry.completed,
          action: entry.action,
          photo: entry.photo || {}
        })),
      });
    }

    // Step 8: Signatures
    if (formData.auditorSignature) {
      json.push({
        question: "Auditor Signature",
        answer: formData.auditorSignature,
      });
    }
    if (formData.supervisorSignature) {
      json.push({
        question: "Supervisor Signature",
        answer: formData.supervisorSignature,
      });
    }
    if (formData.signatureDate) {
      json.push({
        question: "Signature Date",
        answer: formData.signatureDate,
      });
    }

    return json;
  };

const transformDateToISO = (dateStr) => {
  if (!dateStr) return '';
  const [month, day, year] = dateStr.split('-');
  return `${year}-${month}-${day}`;
};

  const handleSubmit = async () => {



   
//     const signatureFields = {
   
//       signatureDate: "Please select Signature Date",
//     };
//     if(!supervisorImage){
//         setSeverity("error");
//         setAlertMessage("Please provide Supervisor Signature");
//         setOpen(true);
//         return;
//     }
 
//     for (let key in signatureFields) {
//       if (!formData[key]) {
//         setSeverity("error");
//         setAlertMessage(signatureFields[key]);
//         setOpen(true);
//         return;
//       }
//     }
//   for (let i = 0; i < formData.auditors.length; i++) {
//   const auditor = formData.auditors[i];
//   if (!auditor.file) {
//     setSeverity("error");
//     setAlertMessage(`Please provide signature/file for auditor ${i + 1}`);
//     setOpen(true);
//     return;
//   }
// }

    try {
      setLoader(true);
  setLoader(true);


formData.auditors.forEach((auditor, index) => {
  console.log(`Auditor ${index + 1}:`, auditor.file?.name, auditor.file?.size);
});

// ===== Step 1: Check actual content (optional but exact check) =====
const readFileAsArrayBuffer = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsArrayBuffer(file);
  });

const compareFiles = async (file1, file2, name1, name2) => {
  const buf1 = await readFileAsArrayBuffer(file1);
  const buf2 = await readFileAsArrayBuffer(file2);

  if (buf1.byteLength !== buf2.byteLength) {
    console.log(`${name1} and ${name2} differ by size`);
    return;
  }

  const arr1 = new Uint8Array(buf1);
  const arr2 = new Uint8Array(buf2);
  const same = arr1.every((val, i) => val === arr2[i]);
 
};

// Compare supervisor with auditors
if (supervisorImage) {
  for (let i = 0; i < formData.auditors.length; i++) {
    if (formData.auditors[i].file) {
      await compareFiles(
        supervisorImage,
        formData.auditors[i].file,
        "Supervisor",
        `Auditor ${i + 1}`
      );
    }
  }
}

// Optionally compare auditors with each other
for (let i = 0; i < formData.auditors.length; i++) {
  for (let j = i + 1; j < formData.auditors.length; j++) {
    if (formData.auditors[i].file && formData.auditors[j].file) {
      await compareFiles(
        formData.auditors[i].file,
        formData.auditors[j].file,
        `Auditor ${i + 1}`,
        `Auditor ${j + 1}`
      );
    }
  }
}
// Collect only NEW uploaded signature files
const filesToUpload = [];

// Supervisor new signature?
if (supervisorImage instanceof File) {
  filesToUpload.push({ key: "supervisor", file: supervisorImage });
}

// Auditor new signatures?
formData.auditors.forEach((aud, idx) => {
  if (aud.file instanceof File) {
    filesToUpload.push({ key: `auditor-${idx}`, file: aud.file });
  }
});
let uploadResults = {};

if (filesToUpload.length > 0) {
  const fd = new FormData();

  filesToUpload.forEach((item) => {
    fd.append("files", item.file);
  });

  const uploadResp = await api.post("/v1/forms/upload-files", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  const uploaded = uploadResp.files || [];

  // Correct mapping: uploaded[i] corresponds to filesToUpload[i]
  uploaded.forEach((fileObj, idx) => {
    uploadResults[filesToUpload[idx].key] = fileObj;
  });
}

const finalSupervisorSignature =
  uploadResults["supervisor"]   // new upload
  || formData.supervisorSignature; // existing
const finalAuditors = formData.auditors.map((aud, idx) => {
  const key = `auditor-${idx}`;

  return {
    ...aud,
    uploadedFile:
      uploadResults[key]          // NEW uploaded signature
      || aud.uploadedFile         // EXISTING signature
      || aud.imgurl               // fallback from edit data
      || null,
  };
});


const jsonData = generateJsonData({
  ...formData,
  signatures: [finalSupervisorSignature],
  auditors: finalAuditors
});
jsonData.push({
  question: "companylist",
  answer: formData.companyJobEntries
});
const mappedids = (formData.companyJobEntries || []).reduce((acc, item) => {
  const pmId = item?.projectManager?.pm_id;
  if (pmId) {
    acc[pmId] = "N";
  }
  return acc;
}, {});



console.log(jsonData,'finalobj')
console.log(formData,'formdatahere')
   let response;
   let obj= {
        emp_id: formData.emp_Id,
        pm_id: formData.pm_id,
        pm_name: formData.pm_name,
        emp_name: formData.auditorName,
        companyid: formData.companyId,
        form_type: "SHP",
        job_id: formData.jobNumber,
        job_description: `${selectedJobName}-(${jobCode})`,
        observer_name: formData.auditorName,
        filled_date:transformDateToISO(formData.auditDate),
        json_data: jsonData,
        documents: "",
        method:formData.method,
        pm_data:mappedids
           
      }
      console.log(obj,'obj')
    

      if(mode==="edit"&&id){
        obj.row_id=id
  response = await api.post('/v1/forms/create-update-form',obj );
      }else{

       response = await api.post('/v1/forms/create-form',obj );
      }

 
  
      if (response.status === 200) {
        setOpen(true);
        setSeverity("success");
        setInfractionImages([])
        setAlertMessage("Submitted Successfully");
        setTimeout(() => {
          setOpen(false);
          navigate(-1);
        }, 2000);
      }
    } catch (error) {
      setSeverity("error");
      setAlertMessage("Something went wrong");
      setOpen(true);
      console.log("Submission error:", error);
    } finally {
      setLoader(false);
    }
  };

  const goToNextPage = () => {
    const showError = (message) => {
      setSeverity("error");
      setAlertMessage(message);
      setOpen(true);
    };
  
    switch (currentPage) {
      case 1: 
        const requiredFields = {
          method: "Please select Method",
          companyId: "Please select Company ID",
          pm_id:"please select Project manager",
          jobNumber: "Please enter Job Number",
          auditorName: "Please enter Employee Name",
          auditDate: "Please select Audit Date",
   
        };
        for (let key in requiredFields) {
          if (!formData[key]) {
            showError(requiredFields[key]);
            return;
          }
        }
          for (let i = 0; i < formData.auditors.length; i++) {
    const auditor = formData.auditors[i];
    if (!auditor.auditorName || auditor.auditorName.trim() === "") {
      showError(`Please enter Auditor Name for auditor ${i + 1}`);
      return;
    }
    if (!auditor.designation || auditor.designation.trim() === "") {
      showError(`Please enter Designation for auditor ${i + 1}`);
      return;
    }
  }
        break;
  
      case 2: // form2: PPE
        const ppeLabels = [
          "Hard hats worn properly",
          "Safety glasses with side shields",
          "Grinding protection (V2G goggles + face shield)",
          "Safety-toed footwear",
          "FRC clothing (long sleeves/pants or coveralls)",
          "Hearing protection in designated areas",
          "Proper gloves for task",
          "Extra PPE available onsite",
          "Reflective vests for spotters",
        ];
        for (let i = 0; i < formData.ppe.length; i++) {
          if (!formData.ppe[i]) {
            showError(`Please fill PPE: ${ppeLabels[i]}`);
            return;
          }
        }
        break;
  
      case 3: // form3: Pre-Job Planning & Training
        const preJobLabels = [
          "Daily safety meetings Conducted",
          "DJSA/CJSA completed and reviewed",
          "Task-specific hazards/controls documented",
          "Permits (Client/NTACT) in place",
          "Operations have valid training cards",
          "Monthly safety training held",
          "Site orientation completed",
        ];
        for (let i = 0; i < formData.preJob.length; i++) {
          if (!formData.preJob[i]) {
            showError(`Please fill Pre-Job Planning: ${preJobLabels[i]}`);
            return;
          }
        }
        break;
  
      case 4: // form4: Site Safety & Postings
        const siteSafetyLabels = [
          "Emergency contacts posted",
          "First aid signage visible",
          "Labour law Posters (5-in-1, OSHA log, etc.)",
          "One Call ticket for excavation",
          "Safety alerts posted",
        ];
        for (let i = 0; i < formData.siteSafety.length; i++) {
          if (!formData.siteSafety[i]) {
            showError(`Please fill Site Safety: ${siteSafetyLabels[i]}`);
            return;
          }
        }
        break;
  
      case 5: // form5: Work Environment AND Working at Heights
        const workEnvironmentLabels = [
          "Smoking areas marked, with extinguisher",
          "Equipment operated by certified personnel",
          "Equipment inspections documented",
          "Equipment safely parked & attachments secured",
          "H2S monitors calibrated and worn properly",
          "First aid kits stocked, accessible",
          "Water & sanitation facilities provided",
          "Housekeeping maintained",
        ];
        for (let i = 0; i < formData.workEnvironment.length; i++) {
          if (!formData.workEnvironment[i]) {
            showError(`Please fill Work Environment: ${workEnvironmentLabels[i]}`);
            return;
          }
        }
  
        const workingAtHeightsLabels = [
          "Fall protection used over 6'",
          "Ladders/scaffolds inspected, secured, labeled",
          "Tools/materials secured in elevated work (Drops Program)",
          "Overhead protection to workers when overhead hazards exist",
          "Open holes marked and covered",
        ];
        for (let i = 0; i < formData.workingAtHeights.length; i++) {
          if (!formData.workingAtHeights[i]) {
            showError(`Please fill Working at Heights: ${workingAtHeightsLabels[i]}`);
            return;
          }
        }
        break;
  
      case 6: // form6: Tools, Electrical & Fire Safety
        const toolsElectricalLabels = [
          "GFCIs used and tested",
          "Cords protected and grounded",
          "Tools inspected, color coded",
          "Fire extinguishers available & inspected",
          "Flammable materials handled per safety protocols",
        ];
        for (let i = 0; i < formData.toolsElectrical.length; i++) {
          if (!formData.toolsElectrical[i]) {
            showError(`Please fill Tools, Electrical & Fire Safety: ${toolsElectricalLabels[i]}`);
            return;
          }
        }
        const weldingGasLabels = [
          "Welding rig inspected",
          "Fire watch available",
          "PPE for grinding (double eye protection)",
          "Compressed gas cylinders secured and labeled",
          "Hoses in good condition and crimped",
        ];
        for (let i = 0; i < formData.weldingGas.length; i++) {
          if (!formData.weldingGas[i]) {
            showError(`Please fill Welding & Compressed Gas Safety: ${weldingGasLabels[i]}`);
            return;
          }
        }
        break;
  
      case 7: // form7: Welding & Compressed Gas Safety
      const excavationLabels = [
        "One Call completed",
        "Excavations barricaded & dry",
        "Access ladders/ramps every 25'",
        "Proper shoring/sloping for 5'+",
        "Utilities marked",
      ];
      for (let i = 0; i < formData.excavation.length; i++) {
        if (!formData.excavation[i]) {
          showError(`Please fill Excavation Safety: ${excavationLabels[i]}`);
          return;
        }
      }
      const subcontractorLabels = [
        "JSA's used for tasks",
        "PPE used correctly",
        "Training cards on hand",
        "SIMOPS JSA signed when applicable",
        "Equipment and First Aid checked",
      ];
      for (let i = 0; i < formData.subcontractor.length; i++) {
        if (!formData.subcontractor[i]) {
          showError(`Please fill Subcontractor Safety: ${subcontractorLabels[i]}`);
          return;
        }
      }
      const emergencyPlanLabels = [
        "Is the SSSP plan available and reviewed",
        "Do employees know what is in the plan",
        "Do employees know how to react to an emergency",
        "Is the emergency plan noted on JSA",
        "Is there a system for accounting everyone onsite",
      ];
      for (let i = 0; i < formData.emergencyPlan.length; i++) {
        if (!formData.emergencyPlan[i]) {
          showError(`Please fill Emergency Action Plan: ${emergencyPlanLabels[i]}`);
          return;
        }
      }
        break;
  

      default:
        break;
    }
  
    // Move to next page only if validations pass
    if (currentPage < 10) setCurrentPage(currentPage + 1);
  };
  
  
  const goToPreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

const fetchEmployeeSuggestions = async (query, entryIndex) => {
  try {
    if (!query) {
      setEmployeeSuggestions([]);
      setEmployeeSuggestionsByEntry(prev => ({
  ...prev,
  [entryIndex]: []
}));

      setShowEmpSuggestions(false);
      return;
    }

    const companyId = formData.companyJobEntries[entryIndex]?.company?.id;

    if (!companyId) {
      setEmployeeSuggestions([]);
      setEmployeeSuggestionsByEntry(prev => ({
  ...prev,
  [entryIndex]: []
}));

      setShowEmpSuggestions(false);
      return;
    }

    const obj = {
      params: {
        company_id: companyId,
        empid: query
      },
    };

    const response = await api.get("/v1/timesheets/get-employee", obj);

if (response.status === 200 && Array.isArray(response.data)) {
  setEmployeeSuggestionsByEntry(prev => ({
    ...prev,
    [entryIndex]: response.data
  }));
  setShowEmpSuggestions(true);
} else {
  setEmployeeSuggestionsByEntry(prev => ({
    ...prev,
    [entryIndex]: []
  }));
  setShowEmpSuggestions(false);
}


  } catch (error) {
    console.error("Error fetching employee suggestions:", error);
  }
};


    
const handleRemoveImage = (index) => {
  // 1️⃣ Remove preview from state
  setInfractionImages((prev) => prev.filter((img) => img.index !== index));

  // 2️⃣ Remove photo key from formData for that infraction
  setFormData((prev) => {
    const updatedInfractions = [...prev.infractions];
    if (updatedInfractions[index]?.photo) {
      delete updatedInfractions[index].photo;
    }
    return { ...prev, infractions: updatedInfractions };
  });
};


  const getImageForIndex = (index) => {
    const found = infractionImages.find((img) => img.index === index);
    return found ? URL.createObjectURL(found.file) : null;
  };
   const handleImageUpload = async (e, index) => {
  const file = e.target.files[0];
  if (!file) return;

  // Preview immediately
  setInfractionImages((prev) => {
    const existing = prev.filter((img) => img.index !== index);
    return [...existing, { index, file }];
  });

  try {
    setLoader(true);

    // 🔺 Prepare upload
    const formDataa = new FormData();
    formDataa.append("files", file);

    // 🔺 Upload image to API
    const imgresponse = await api.post("/v1/forms/upload-files", formDataa, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    // 🔺 Extract uploaded file info (adjust based on your backend response)
    const uploadedFile = Array.isArray(imgresponse?.files)
      ? imgresponse.files[0]
      : imgresponse?.file || null;

    if (uploadedFile) {
      // 🔺 Save uploaded file data in that infraction row
      setFormData((prev) => {
        const updatedInfractions = [...prev.infractions];
        updatedInfractions[index] = {
          ...updatedInfractions[index],
          photo: uploadedFile,
        };
        return { ...prev, infractions: updatedInfractions };
      });
    }
  } catch (error) {
    console.error("File upload failed:", error);
  } finally {
    setLoader(false);
  }
};
   const handlesafetyimageUpload = async (e, index) => {
  const file = e.target.files[0];
  if (!file) return;

 

  try {
    setLoader(true);

    // 🔺 Prepare upload
    const formDataa = new FormData();
    formDataa.append("files", file);

    // 🔺 Upload image to API
    const imgresponse = await api.post("/v1/forms/upload-files", formDataa, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    // 🔺 Extract uploaded file info (adjust based on your backend response)
    const uploadedFile = Array.isArray(imgresponse?.files)
      ? imgresponse.files[0]
      : imgresponse?.file || null;

    if (uploadedFile) {
    
    }
  } catch (error) {
    console.error("File upload failed:", error);
  } finally {
    setLoader(false);
  }
};

const fetchJobSuggestions = async (query,entryIndex) => {
  try {
    if (!query) {
      setSuggestions([]);
      setShowSuggestions(false);
      setSelectedJobName('');
      return;
    }

    // Handle overhead job directly for query of 1 to 4 zeros
    if (/^0{1,4}$/.test(query)) {
      const overheadJob = {
        job_num: "0000",
        job_name: "Overhead",
      };
      setSuggestions([overheadJob]);
      setShowSuggestions(true);
      return;
    }
const companyId = formData.companyJobEntries[entryIndex].company.id

    const response = await api.get(`/v1/timesheets/get-jobs`, {
      params: {
        company_id: companyId,
        job_num: query,
      }
    });

    if (response.status === 200) {
      setSuggestions(response.data || []);
      setShowSuggestions(true);
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  } catch (error) {
    console.error("Error fetching jobcodes:", error);
  }
};

    
    const handleEmployeeSelect = (emp) => {
      setFormData((prev) => ({
        ...prev,
        auditorName: `${emp.firstname} ${emp.lastname}`,
        emp_Id: emp.empid, // optional: if you want to store the ID
      }));
      setEmployeeId(emp.empid);
      setselectedempobj(emp);
      setShowEmpSuggestions(false);
      setEmployeeSuggestions([]);
    };
  const handleJobCodeSelect = (code, entryIndex) => {
  // update selected row
  updateJobEntry(entryIndex, {
    job_num: code.job_num,
    job_name: code.job_name,
  });

  // first row still drives global job state (keep this if needed)
  if (entryIndex === 0) {
    setJobCode(code.job_num);
    setSelectedJobName(code.job_name);
  }

  // close dropdown for ALL rows
  setSuggestions([]);
  setShowSuggestions(false);
  setActiveSuggestionIndex(null);
};

    // const handleJobCodeSelect = (code) => {
    //   setJobCode(code.job_num);
    //   setSelectedJobName(code.job_name);
    //   setSuggestions([]);
    //   setShowSuggestions(false);
    
    //   // Also update formData.jobNumber
    //   setFormData((prev) => ({
    //     ...prev,
    //     jobNumber: code.job_num,
    //   }));
    // };
   const fetchTabsData = async () => {
        try {
          const response = await api.get(`/v1/timesheets/company-details`);
      
          if (response.status === 200 ) {
            setCompanyTabs(response.data);
            setSelectedCompanyId(response.data[0]?.id);
          }else{
          
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }finally{
          
        }
      };
      
      useEffect(()=>{
        fetchTabsData()
      },[])
      useEffect(()=>{
console.log(formData,'formdataupdated')
      },[formData])

          useEffect(() => {
            const handleClickOutside = (event) => {
              if (jobInputRef.current && !jobInputRef.current.contains(event.target)) {
                setShowSuggestions(false);
              }
         
              if (empInputRef.current && !empInputRef.current.contains(event.target)) {
                setShowEmpSuggestions(false);
              }
            };
            document.addEventListener('mousedown', handleClickOutside);
            return () => document.removeEventListener('mousedown', handleClickOutside);
          }, []);

 const handleGlobalUpload = (section, index, comment, files) => {
  setFormData((prev) => {
    const updated = { ...prev };
    if (!updated[section] || !Array.isArray(updated[section])) return prev;

    const target = updated[section][index] || {};
    updated[section][index] = {
      ...target,
      answer: "NO",
      comment: comment || target.comment || "",
      images: [
        ...(target.images || []),
        ...files.filter((f) => typeof f === "string"),
      ],
      localpreviews: [
        ...(target.localpreviews || []),
        ...files
          .filter((f) => f instanceof File)
          .map((f) => URL.createObjectURL(f)),
      ],
    };
    return updated;
  });
 handleModalSubmit(comment,files)
setIsSafetyModalOpen(false)
  setIsGlobalUploadModalOpen(false);
};
const selectedCompanyIds = formData.companyJobEntries
  .map(e => e.company?.id)
  .filter(Boolean);

  return (
    <div className="flex flex-col min-h-screen bg-white px-8 py-6">
      {/* Header */}
      <div className="flex items-center mb-6">
        <button onClick={() => navigate('/forms')} className="text-2xl mr-4">
          <ArrowBackIcon />
        </button>
        <h1 className="text-xl font-bold text-gray-800">
          {t("SAFETY AND HEALTH PRIMARY AUDIT FORM")}
        </h1>
      </div>

      {/* Page Info */}
      <div className="text-sm text-gray-600 flex font-inter mb-4">
        Page {currentPage} of {totalPages}
      </div>

      {/* Steps */}
      <div className="flex items-center justify-between mb-8">
        {steps.map((label, index) => (
          <div key={index} className="flex flex-col items-center flex-1">
            <div
              className={`rounded-full w-10 h-10 flex items-center justify-center ${
                index === currentPage - 1
                  ? "bg-black text-white"
                  : "bg-gray-200 text-black"
              }`}
            >
              {index + 1}
            </div>
            <span className="text-xs text-center mt-2 font-inter break-words">
              {t(label)}
            </span>
          </div>
        ))}
      </div>
      <div className="m-2 flex justify-end w-full px-4">
      <button
        onClick={() => changeLanguage('en')}
        className={`px-3 py-1 rounded ${selectedLanguage === 'en' ? 'bg-black text-white' : 'bg-white text-black border border-gray-300'}`}
      >
        English
      </button>
      <button
        onClick={() => changeLanguage('es')}
        className={`px-3 py-1 rounded ${selectedLanguage === 'es' ? 'bg-black text-white' : 'bg-white text-black border border-gray-300'}`}
      >
        Español
      </button>
    </div>
      {/* {currentPage === 1 && (
        <>
          <div className="bg-black flex text-white px-4 py-2 border border-gray-300 rounded-tr-xl rounded-tl-xl mb-6 text-lg font-semibold">
            {t("Step 1: Audit Information")}
          </div>
          <div className='w-[15%] ml-14'>
      <label className="block text-sm text-left font-medium">{t("Method")}</label>
      <select
  className="w-full border rounded px-3 py-[10px]  text-sm font-inter mt-1"
  value={formData.method || ""}
  onChange={(e) => {
    setFormData((prev) => ({
      ...prev,
      method: e.target.value,
    }));
  }}
>
  <option className="font-inter text-xs" value="">{t("Select Method")}</option>
  <option className="font-inter text-xs" value="Filled Out">{t("Filled Out")}</option>
  <option className="font-inter text-xs" value="Uploaded">{t("Uploaded")}</option>
  <option className="font-inter text-xs" value="Capture">{t("Capture")}</option>
</select>
    </div>
          <div className="flex flex-col md:flex-row shadow-lg rounded-bl-xl rounded-br-xl gap-8">
            <div className="max-w-[50%]">
              <div className="ml-[35px] p-6 w-[100%]">
                <div className="mb-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-gray-700 mb-1 text-sm font-medium text-left">
                        {t("Company Id")}
                      </label>
                      <select
  className="w-full border rounded px-3 py-[10px] text-sm font-inter mt-1"
  value={formData.companyId || ""}
  onChange={(e) => {
    const selectedId = e.target.value ? parseInt(e.target.value, 10) : null;
         setSelectedCompanyId(selectedId)
    setFormData((prev) => ({
      ...prev,
      companyId: selectedId,
    }));
      fetchpm(selectedId)
  }}
>
  <option className="font-inter text-xs" value="">{t("Select a Company")}</option>
  {companyTabs.map((company) => (
    <option className="font-inter text-xs" key={company.id} value={company.id}>
      {t(company.name)}
    </option>
  ))}
</select>
                    </div>
                       <div className="flex-1">
                <label className="block font-bold text-sm text-left">{t("Project Manger")}</label>
<select
  className="w-full border rounded px-3 py-[10px] text-sm font-inter mt-1"
  value={formData.pm_id || ""}
   onChange={(e) => {
    const selectedId = e.target.value ? parseInt(e.target.value, 10) : null;
    const selectedPM = pmolist.find((pmoo) => pmoo.id === selectedId);
    const selectedName = selectedPM ? `${selectedPM.firstname} ${selectedPM.lastname}` : "";

    setFormData((prev) => ({
      ...prev,
      pm_id: selectedId,
      pm_name: selectedName,
    }));
  }}
>
  <option className="font-inter text-xs" value="">{t("Select Project Manager")}</option>
  {pmolist.map((pmoo) => (
    <option className="font-inter text-xs" key={pmoo.id} value={pmoo.id}>
      {t(pmoo?.firstname+" "+pmoo?.lastname)}
    </option>
  ))}
</select>



                   </div>
                    <div className="flex-1 relative" ref={jobInputRef}>
                <label className="block text-sm font-medium  mb-1 text-left">{t("JOB")} #</label>
                <input
                    placeholder='Enter job Id'
                  type="text"
                  className="w-full border border-gray-300 rounded p-2 text-sm"
                  value={formData.jobNumber}
                  onChange={(e) => {
                    const val = e.target.value;
                handleInputChange({ target: { value: val } }, null, 'jobNumber');
                    
                    if (!val.trim()) {
                      setSuggestions([]);
                      setShowSuggestions(false);
                    } else {
                      fetchJobSuggestions(val); // your function to get suggestions
                      setShowSuggestions(true);
                    }
                  }}
                    onBlur={() => {
    const isValid = suggestions.some((s) => s.job_num === formData.jobNumber);
    if (!isValid) {
      setFormData((prev) => ({
        ...prev,
        jobNumber: '',
      }));
      setJobCode('');
      setSelectedJobName('');
    }
  }}
             onKeyDown={(e) => {
    if (e.key === 'Tab' && suggestions?.length) {
      handleJobCodeSelect(suggestions[0]);
      e.preventDefault();
    }
    if (e.key === 'ArrowDown') {
      setHoveredJobIndex((prev) =>
        prev === null || prev === suggestions.length - 1 ? 0 : prev + 1
      );
    }
    if (e.key === 'ArrowUp') {
      setHoveredJobIndex((prev) =>
        prev === null || prev === 0 ? suggestions.length - 1 : prev - 1
      );
    }
  }}
            />
                   {showSuggestions && suggestions.length > 0 && (
                <ul className="absolute z-10 mt-1 left-0 text-start bg-white border border-gray-200 rounded-md shadow-lg max-h-[400px] overflow-y-auto text-sm w-full whitespace-nowrap">
                  {suggestions.map((code, index) => (
                    <li
                      key={index}
                      onClick={() => handleJobCodeSelect(code)}
                      onMouseEnter={() => setHoveredJobIndex(index)}
        className={`px-2 py-1 cursor-pointer hover:bg-gray-100 ${index === hoveredJobIndex ? 'bg-gray-100' : ''}`}
      >
                    
                      {code.job_num} - {code.job_name}
                    </li>
                  ))}
                </ul>
              )}
              </div>
                  </div>
                </div>
                <div className="grid grid-cols-1 gap-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-gray-700 mb-1 text-sm font-medium text-left">
                        {t("Employee Name")}
                      </label>
                      <div className="relative" ref={empInputRef}>
  <input
    type="text"
    placeholder='Enter Employee id'
    className="w-full border border-gray-300 rounded p-2 py-2.5 text-sm"
    value={formData.auditorName}
    onChange={(e) => {
      const val = e.target.value;

      handleInputChange(e, null, 'auditorName');
      if (!val.trim()) {
        setselectedempobj({});
        setEmployeeSuggestions([]);
        setShowEmpSuggestions(false);
      } else {
        fetchEmployeeSuggestions(val);
      }
    }}
     onBlur={() => {
 
      if (!selectedempobj || Object.keys(selectedempobj).length === 0) {
        setFormData((prev) => ({
          ...prev,
          auditorName: '',
        }));
      }
    }}
     onKeyDown={(e) => {
    if (e.key === 'Tab' &&employeeSuggestions?.length) {
      handleEmployeeSelect(employeeSuggestions[0]);
      e.preventDefault();
    }
    if (e.key === 'ArrowDown') {
      setHoveredEmpIndex((prev) =>
        prev === null || prev === employeeSuggestions.length - 1 ? 0 : prev + 1
      );
    }
    if (e.key === 'ArrowUp') {
      setHoveredEmpIndex((prev) =>
        prev === null || prev === 0 ? employeeSuggestions.length - 1 : prev - 1
      );
    }
  }}
  />
  {showEmpSuggestions && employeeSuggestions.length > 0 && (
    <ul className="absolute z-10 mt-1 left-0 text-start bg-white border border-gray-200 rounded-md shadow-lg max-h-[300px] overflow-y-auto text-sm w-full">
      {employeeSuggestions.map((emp, index) => (
        <li
          key={index}
          onClick={() => handleEmployeeSelect(emp)}
          onMouseEnter={() => setHoveredEmpIndex(index)}
        className={`px-2 py-1 cursor-pointer hover:bg-gray-100 ${index === hoveredEmpIndex ? 'bg-gray-100' : ''}`}
        >
          {`${emp.firstname} ${emp.lastname}`} - {emp.empid}
        </li>
      ))}
    </ul>
  )}
                  </div>
                    </div>
                    <div>
                      <label className="block text-gray-700 mb-1 text-sm font-medium text-left">
                        {t("Audit Date")}
                      </label>
                      <DatePicker
  selected={formData.auditDate ? new Date(formData.auditDate) : null} 
  onChange={(date) =>
  handleInputChange(
    {
      target: {
        value: date
          ? `${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}-${date.getFullYear()}`
          : '',
      },
    },
    null,
    'auditDate'
  )
}

  className="w-full border border-gray-300 rounded-md p-2" 
  wrapperClassName="w-full"
  dateFormat="MM-dd-yyyy" 
  maxDate={new Date()} 
  placeholderText="MM-DD-YYYY" 
/>
                    </div>
                  </div>
                 
                </div>
            <div className="grid grid-cols-1 ">


  {formData.auditors.map((auditor, index) => (
  <div
    key={index}
    className="flex items-end gap-3 p-3"
  >

    <div className="flex flex-col flex-1">
      <label className="block text-gray-700 mb-1 text-sm font-medium text-left">
        Auditor Name
      </label>
      <input
        type="text"
        placeholder="Enter Auditor Name"
        value={auditor.auditorName}
        onChange={(e) => {
          const updated = [...formData.auditors];
          updated[index].auditorName = e.target.value;
          setFormData((prev) => ({ ...prev, auditors: updated }));
        }}
        className="w-full border border-gray-300 rounded p-2 py-2.5 text-sm"
      />
    </div>

    <div className="flex flex-col flex-1">
      <label className="block text-gray-700 mb-1 text-sm font-medium text-left">
        Designation
      </label>
      <input
        type="text"
        placeholder="Enter Designation"
        value={auditor.designation}
        onChange={(e) => {
          const updated = [...formData.auditors];
          updated[index].designation = e.target.value;
          setFormData((prev) => ({ ...prev, auditors: updated }));
        }}
        className="w-full border border-gray-300 rounded p-2 py-2.5 text-sm"
      />
    </div>

    <div className="flex items-center mb-2 gap-2">

      {index === 0 && (
        <button
          type="button"
          onClick={() =>
            setFormData((prev) => ({
              ...prev,
              auditors: [
                ...prev.auditors,
                     { auditorName: "", designation: "", file: "", imgurl: "" }, 
              ],
            }))
          }
          className="text-green-600 hover:text-green-800 text-xl font-bold"
          title="Add Auditor"
        >
          +
        </button>
      )}

     
      {formData.auditors.length > 1 && (
        <button
          type="button"
          onClick={() => {
            const updated = formData.auditors.filter((_, i) => i !== index);
            setFormData((prev) => ({ ...prev, auditors: updated }));
          }}
          className="text-red-500 hover:text-red-700 text-xl font-bold"
          title="Delete Auditor"
        >
          ✕
        </button>
      )}
    </div>
  </div>
))}

</div>


              </div>
              
            </div>
            <div className="w-full max-w-[50%] ">
  <div className="rounded-lg mt-14 ml-6 w-[90%] bg-gray-100 border p-4">
    <div className="flex justify-between mb-4 text-gray-800 border-b pb-2">
      <span className="font-inter text-sm font-medium font-semibold">{t("HEALTH SAFETY & ENVIRONMENTAL")}</span>
      <span className="text-sm font-inter">{t("Document Number:")} 18-5-D</span>
    </div>
    <div className="text-sm text-gray-700 space-y-2 w-full">
      <div className="flex w-full">
        <p className="w-1/2 font-inter text-black text-left">{t("Document Name:")}</p>
        <span className="w-1/2 text-left">{t("SAFETY AND HEALTH PRIMARY AUDIT FORM")}</span>
      </div>
      <div className="flex w-full">
        <p className="w-1/2 font-inter text-black text-left">{t("Section")}:</p>
        <span className="w-1/2 text-left">HSE-18</span>
      </div>
      <div className="flex w-full">
        <p className="w-1/2 font-inter text-black text-left">{t("Revision")}:</p>
        <span className="w-1/2 text-left">2</span>
      </div>
      <div className="flex w-full">
        <p className="w-1/2 font-inter text-black text-left">{t("Date")}:</p>
        <span className="w-1/2 text-left">
          {formData.auditDate}
        </span>
      </div>
    </div>
  </div>
</div>

            
          </div>
  
        </>
      )} */}
{currentPage === 1 && (
  <>
    <div className="bg-black flex text-white px-4 py-2 border border-gray-300 rounded-tr-xl rounded-tl-xl mb-6 text-lg font-semibold">
      {t("Step 1: Audit Information")}
    </div>
    
    {/* Method Dropdown */}
    <div className='w-[15%] ml-14 mb-6'>
      <label className="block text-sm text-left font-medium">{t("Method")}</label>
      <select
        className="w-full border rounded px-3 py-[10px] text-sm font-inter mt-1"
        value={formData.method || ""}
        onChange={(e) => {
          setFormData((prev) => ({
            ...prev,
            method: e.target.value,
          }));
        }}
      >
        <option className="font-inter text-xs" value="">{t("Select Method")}</option>
        <option className="font-inter text-xs" value="Filled Out">{t("Filled Out")}</option>
        <option className="font-inter text-xs" value="Uploaded">{t("Uploaded")}</option>
        <option className="font-inter text-xs" value="Capture">{t("Capture")}</option>
      </select>
    </div>

    <div className="flex flex-col md:flex-row shadow-lg rounded-bl-xl rounded-br-xl gap-8">
      <div className="max-w-[50%]">
        <div className="ml-[35px] p-6 w-[100%]">
          
          {/* Multiple Company-Job-PM-Employee Entries */}
          <div className="space-y-4 mb-6">
            {/* <h3 className="text-sm font-semibold text-gray-700 text-left">
              {t("Company, Job, PM & Employee Information")}
            </h3> */}
            
            {formData.companyJobEntries.map((entry, entryIndex) => (
              <div key={entryIndex} className="border rounded-lg p-4 bg-gray-50 relative">
                {/* Delete Button (only for entries after first) */}
                {entryIndex > 0 && (
                  <button
                    type="button"
                    onClick={() => removeCompanyJobEntry(entryIndex)}
                    className="absolute top-2 right-2 text-red-500 hover:text-red-700"
                    title="Remove Entry"
                  >
                    <DeleteIcon />
                  </button>
                )}
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Company ID */}
                  <div>
                    {/* <label className="block text-gray-700 mb-1 text-sm font-medium text-left">
                      {t("Company Id")} {entryIndex > 0 && `(${entryIndex + 1})`}
                    </label> */}
                    <select
                      className="w-full border rounded px-3 py-[10px] text-sm font-inter mt-1"
                      value={entry.company.id || ""}
                      onChange={(e) => {
                        const selectedId = e.target.value ? parseInt(e.target.value, 10) : null;
                        const selectedCompany = companyTabs.find(c => c.id === selectedId);
                        const companyName = selectedCompany ? selectedCompany.name : "";
                        handleCompanyJobSelect(entryIndex, selectedId, companyName);
                      }}
                    >
                      <option className="font-inter text-xs" value="">
                        {t("Select a Company")}
                      </option>
                 {companyTabs.map((company) => {
  const alreadyUsed =
    selectedCompanyIds.includes(company.id) &&
    company.id !== entry.company.id; // allow current row value

  return (
    <option
      key={company.id}
      value={company.id}
      disabled={alreadyUsed}
      className="font-inter text-xs"
    >
      {t(company.name)}
    </option>
  );
})}

                    </select>
                  </div>

                  {/* Job Number */}
                  <div className="flex-1 relative">
                    <label className="block text-sm font-medium mb-1 text-left">
                      {t("JOB")} #
                    </label>
                    <input
                      placeholder="Enter job Id"
                      type="text"
                      className="w-full border border-gray-300 rounded p-2 text-sm"
                      value={entry.job.job_num}
                      onChange={(e) => {
                        const val = e.target.value;
                        updateJobEntry(entryIndex, { job_num: val });
                        setActiveSuggestionIndex(entryIndex);
                        fetchJobSuggestions(val, entryIndex);
                        setShowSuggestions(true);
                      }}
                    />
                    {activeSuggestionIndex === entryIndex && showSuggestions && suggestions.length > 0 && (
                      <ul className="absolute z-10 mt-1 left-0 text-start bg-white border border-gray-200 rounded-md shadow-lg max-h-[400px] overflow-y-auto text-sm w-full whitespace-nowrap">
                        {suggestions.map((code, index) => (
                          <li
                            key={index}
                            onClick={() => handleJobCodeSelect(code, entryIndex)}
                            onMouseEnter={() => setHoveredJobIndex(index)}
                            className={`px-2 py-1 cursor-pointer hover:bg-gray-100 ${
                              index === hoveredJobIndex ? "bg-gray-100" : ""
                            }`}
                          >
                            {code.job_num} - {code.job_name}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>

                  {/* Project Manager */}
                  <div className="flex-1">
                    <label className="block font-bold text-sm text-left">{t("Project Manager")}</label>
                    <select
                      className="w-full border rounded px-3 py-[10px] text-sm font-inter mt-1"
                      value={entry.projectManager?.pm_id || ""}
                      onChange={(e) => {
                        const selectedId = e.target.value ? parseInt(e.target.value, 10) : null;
      const selectedPM = (pmByEntry[entryIndex] || []).find(
  (p) => p.id === selectedId
);

const selectedName = selectedPM
  ? `${selectedPM.firstname} ${selectedPM.lastname}`
  : "";


                        updatePMEntry(entryIndex, {
                          pm_id: selectedId,
                          pm_name: selectedName
                        });
                      }}
                    >
                      <option className="font-inter text-xs" value="">{t("Select Project Manager")}</option>
                      {pmByEntry[entryIndex]?.map((pmoo) => (
                        <option className="font-inter text-xs" key={pmoo.id} value={pmoo.id}>
                          {t(pmoo?.firstname + " " + pmoo?.lastname)}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Employee Name */}
                  <div>
                    <label className="block text-gray-700 mb-1 text-sm font-medium text-left">
                      {t("Employee Name")}
                    </label>
                    <div className="relative" ref={empInputRef}>
                      <input
                        type="text"
                        placeholder="Enter Employee id"
                        className="w-full border border-gray-300 rounded p-2 py-2.5 text-sm"
                        value={entry.employee?.emp_name || ""}
                        onChange={(e) => {
                          const val = e.target.value;
                          updateEmployeeEntry(entryIndex, { 
                            emp_id: entry.employee?.emp_id || null, 
                            emp_name: val 
                          });
                          
                          if (!val.trim()) {
                            setEmployeeSuggestions([]);
                            setEmployeeSuggestionsByEntry(prev => ({
  ...prev,
  [entryIndex]: []
}));

                            setShowEmpSuggestions(false);
                          } else {
                fetchEmployeeSuggestions(val, entryIndex);
setActiveSuggestionIndex(entryIndex);

                          }
                        }}
                      />
                      {activeSuggestionIndex === entryIndex && showEmpSuggestions && (employeeSuggestionsByEntry[entryIndex] || []).length > 0 && (
                        <ul className="absolute z-10 mt-1 left-0 text-start bg-white border border-gray-200 rounded-md shadow-lg max-h-[300px] overflow-y-auto text-sm w-full">
                          {(employeeSuggestionsByEntry[entryIndex] || []).map((emp, index) => (
                            <li
                              key={index}
                            onClick={() => {
  updateEmployeeEntry(entryIndex, {
    emp_id: emp.empid,
    emp_name: `${emp.firstname} ${emp.lastname}`
  });

  setEmployeeSuggestionsByEntry(prev => ({
    ...prev,
    [entryIndex]: []
  }));

  setShowEmpSuggestions(false);
}}
                              onMouseEnter={() => setHoveredEmpIndex(index)}
                              className={`px-2 py-1 cursor-pointer hover:bg-gray-100 ${index === hoveredEmpIndex ? 'bg-gray-100' : ''}`}
                            >
                              {`${emp.firstname} ${emp.lastname}`} - {emp.empid}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </div>
                
                {/* Display selected values */}
                {/* {(entry.company.name || entry.job.job_name || entry.projectManager?.pm_name || entry.employee?.emp_name) && (
                  <div className="mt-3 p-2 bg-blue-50 rounded text-xs">
                    {entry.company.name && (
                      <div className="text-gray-700">
                        <strong>Company:</strong> {entry.company.name} (ID: {entry.company.id})
                      </div>
                    )}
                    {entry.job.job_name && (
                      <div className="text-gray-700 mt-1">
                        <strong>Job:</strong> {entry.job.job_name} ({entry.job.job_num})
                      </div>
                    )}
                    {entry.projectManager?.pm_name && (
                      <div className="text-gray-700 mt-1">
                        <strong>PM:</strong> {entry.projectManager.pm_name}
                      </div>
                    )}
                    {entry.employee?.emp_name && (
                      <div className="text-gray-700 mt-1">
                        <strong>Employee:</strong> {entry.employee.emp_name}
                      </div>
                    )}
                  </div>
                )} */}
              </div>
            ))}
            
            {/* Add Entry Button */}
            <button
              type="button"
              onClick={addCompanyJobEntry}
              className="flex items-center gap-2 text-blue-600 hover:text-blue-800 font-medium text-sm"
            >
              <AddCircleIcon fontSize="small" /> {t("Add Another Entry")}
            </button>
          </div>

          {/* Audit Date */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-gray-700 mb-1 text-sm font-medium text-left">
                {t("Audit Date")}
              </label>
              <DatePicker
                selected={formData.auditDate ? new Date(formData.auditDate) : null}
                onChange={(date) =>
                  handleInputChange(
                    {
                      target: {
                        value: date
                          ? `${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}-${date.getFullYear()}`
                          : '',
                      },
                    },
                    null,
                    'auditDate'
                  )
                }
                className="w-full border border-gray-300 rounded-md p-2"
                wrapperClassName="w-full"
                dateFormat="MM-dd-yyyy"
                maxDate={new Date()}
                placeholderText="MM-DD-YYYY"
              />
            </div>
          </div>

          {/* Auditors Section */}
          <div className="grid grid-cols-1 mt-6">
            {formData.auditors.map((auditor, index) => (
              <div key={index} className="flex items-end gap-3 p-3">
                <div className="flex flex-col flex-1">
                  <label className="block text-gray-700 mb-1 text-sm font-medium text-left">
                    Auditor Name
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Auditor Name"
                    value={auditor.auditorName}
                    onChange={(e) => {
                      const updated = [...formData.auditors];
                      updated[index].auditorName = e.target.value;
                      setFormData((prev) => ({ ...prev, auditors: updated }));
                    }}
                    className="w-full border border-gray-300 rounded p-2 py-2.5 text-sm"
                  />
                </div>

                <div className="flex flex-col flex-1">
                  <label className="block text-gray-700 mb-1 text-sm font-medium text-left">
                    Designation
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Designation"
                    value={auditor.designation}
                    onChange={(e) => {
                      const updated = [...formData.auditors];
                      updated[index].designation = e.target.value;
                      setFormData((prev) => ({ ...prev, auditors: updated }));
                    }}
                    className="w-full border border-gray-300 rounded p-2 py-2.5 text-sm"
                  />
                </div>

                <div className="flex items-center mb-2 gap-2">
                  {index === 0 && (
                    <button
                      type="button"
                      onClick={() =>
                        setFormData((prev) => ({
                          ...prev,
                          auditors: [
                            ...prev.auditors,
                            { auditorName: "", designation: "", file: "", imgurl: "" },
                          ],
                        }))
                      }
                      className="text-green-600 hover:text-green-800 text-xl font-bold"
                      title="Add Auditor"
                    >
                      +
                    </button>
                  )}

                  {formData.auditors.length > 1 && (
                    <button
                      type="button"
                      onClick={() => {
                        const updated = formData.auditors.filter((_, i) => i !== index);
                        setFormData((prev) => ({ ...prev, auditors: updated }));
                      }}
                      className="text-red-500 hover:text-red-700 text-xl font-bold"
                      title="Delete Auditor"
                    >
                      ✕
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Right side info box */}
      <div className="w-full max-w-[50%]">
        <div className="rounded-lg mt-14 ml-6 w-[90%] bg-gray-100 border p-4">
          <div className="flex justify-between mb-4 text-gray-800 border-b pb-2">
            <span className="font-inter text-sm font-medium font-semibold">{t("HEALTH SAFETY & ENVIRONMENTAL")}</span>
            <span className="text-sm font-inter">{t("Document Number:")} 18-5-D</span>
          </div>
          <div className="text-sm text-gray-700 space-y-2 w-full">
            <div className="flex w-full">
              <p className="w-1/2 font-inter text-black text-left">{t("Document Name:")}</p>
              <span className="w-1/2 text-left">{t("SAFETY AND HEALTH PRIMARY AUDIT FORM")}</span>
            </div>
            <div className="flex w-full">
              <p className="w-1/2 font-inter text-black text-left">{t("Section")}:</p>
              <span className="w-1/2 text-left">HSE-18</span>
            </div>
            <div className="flex w-full">
              <p className="w-1/2 font-inter text-black text-left">{t("Revision")}:</p>
              <span className="w-1/2 text-left">2</span>
            </div>
            <div className="flex w-full">
              <p className="w-1/2 font-inter text-black text-left">{t("Date")}:</p>
              <span className="w-1/2 text-left">
                {formData.auditDate}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
)}

  {currentPage === 2 && (
  <>
    <div className="bg-gray-100 rounded-lg shadow-md p-0 mb-6">
      <div className="bg-black flex text-white text-lg font-inter px-6 py-4 rounded-t-lg">
        {t("Step 2: PPE (Personal Protective Equipment)")}
      </div>
      <div className="p-6">
        <div className="bg-white rounded-lg shadow-md p-0">
          <div className="bg-gray-800 flex text-white text-lg font-inter px-6 py-4 rounded-t-lg">
            {t("SECTION 1: PPE (Personal Protective Equipment)")}
          </div>

          <div className="p-6 grid grid-cols-1 md:grid-cols-1 gap-6">
            {[
              "Hard hats worn properly",
              "Safety glasses with side shields",
              "Grinding protection (V2G goggles + face shield)",
              "Safety-toed footwear",
              "FRC clothing (long sleeves/pants or coveralls)",
              "Hearing protection in designated areas",
              "Proper gloves for task",
              "Extra PPE available onsite",
              "Reflective vests for spotters",
            ].map((question, index) => {
              const isGrayBackground =
                question === "Safety glasses with side shields" ||
                question === "Safety-toed footwear" ||
                question === "Hearing protection in designated areas" ||
                question === "Extra PPE available onsite";

              return (
             <div
  key={index}
  className={`border rounded-md p-4 flex flex-col font-inter justify-between min-h-[150px] ${
    isGrayBackground ? "bg-gray-100" : "bg-white"
  }`}
>
  <div className="text-gray-800 font-medium mb-4 text-left w-full">
    {`${index + 1}. ${t(question)}`}
  </div>
  <hr className="border-t border-gray-300 mb-4" />

  <div className="flex justify-center font-inter space-x-8">
    {/* YES Option */}
    <label className="flex items-center text-green-500 text-sm font-inter cursor-pointer">
      <input
        type="radio"
        name={`q${index}`}
        value="YES"
        checked={formData.ppe[index]?.answer === "YES"}
        onChange={() => handleRadioChange("ppe", index, "YES")}
        className="mb-1 mr-1"
      />
      <span className="mb-[5px]">{t("YES")}</span>
    </label>

    {/* NO Option */}
    <label className="flex items-center text-red-500 text-sm font-inter cursor-pointer">
      <input
        type="radio"
        name={`q${index}`}
        value="NO"
        checked={formData.ppe[index]?.answer === "NO"}
        onChange={() => handleRadioChange("ppe", index, "NO")}
        className="mb-1 mr-1"
      />
      <span className="mb-[5px]">{t("NO")}</span>
    </label>

    {/* N/A Option */}
    <label className="flex items-center text-gray-500 text-sm font-inter cursor-pointer">
      <input
        type="radio"
        name={`q${index}`}
        value="N/A"
        checked={formData.ppe[index]?.answer === "N/A"}
        onChange={() => handleRadioChange("ppe", index, "N/A")}
        className="mb-1 mr-1"
      />
      <span className="mb-[5px]">N/A</span>
    </label>
  </div>

{formData.ppe[index]?.answer === "NO" &&
  (formData.ppe[index]?.comment ||
    (formData.ppe[index]?.images?.length > 0 ||
      formData.ppe[index]?.localpreviews?.length > 0)) && (
    <div className="mt-4 text-start border-t pt-3 text-sm text-gray-700">
      {/* 🟢 Comment */}
      {formData.ppe[index]?.comment && (
        <p className="mb-2 italic text-gray-800">
          <strong>Comment:</strong> {formData.ppe[index].comment}
        </p>
      )}

      {/* 🟢 Multiple Uploaded Images / Local Previews */}
     {(formData.ppe[index]?.images?.length > 0 ||
  formData.ppe[index]?.localpreviews?.length > 0) && (
  <div className="grid grid-cols-3 sm:grid-cols-4 gap-3 mt-2">

    {/* 1️⃣ SHOW LOCAL PREVIEWS */}
    {(formData.ppe[index]?.localpreviews || []).map((url, i) => (
      <div key={`local-${i}`} className="relative group">
        <img
          src={url}
          alt={`Local preview ${i + 1}`}
          className="w-24 h-24 object-cover rounded-md border"
        />
        <button
          onClick={() =>
            setFormData((prev) => {
              const updated = { ...prev };
              const target = updated.ppe[index];

              updated.ppe[index] = {
                ...target,
                localpreviews: target.localpreviews.filter((_, idx) => idx !== i)
              };

              return updated;
            })
          }
          className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-1 text-xs hover:bg-black/80 opacity-0 group-hover:opacity-100 transition"
        >
          ✕
        </button>
      </div>
    ))}

    {/* 2️⃣ SHOW BACKEND IMAGES (file_name) WHEN NO LOCAL PREVIEW */}
    {formData.ppe[index]?.localpreviews?.length === 0 &&
      (formData.ppe[index]?.images || []).map((img, i) => (
        <div key={`img-${i}`} className="relative group">
          <img
            src={`https://hub2.ntactops.com/ntact/files/forms_files/${img.file_name}`}
            alt={`Uploaded image ${i + 1}`}
            className="w-24 h-24 object-cover rounded-md border"
          />
          <button
            onClick={() =>
              setFormData((prev) => {
                const updated = { ...prev };
                const target = updated.ppe[index];

                updated.ppe[index] = {
                  ...target,
                  images: target.images.filter((_, idx) => idx !== i)
                };

                return updated;
              })
            }
            className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-1 text-xs hover:bg-black/80 opacity-0 group-hover:opacity-100 transition"
          >
            ✕
          </button>
        </div>
      ))}
  </div>
)}

    </div>
  )}


</div>

              );
            })}
          </div>
        </div>
      </div>
      
    </div>
  </>
)}


  {currentPage === 3 && (
  <>
    <div className="bg-gray-100 rounded-lg shadow-md p-0 mb-6">
      <div className="bg-black flex text-white text-lg font-inter px-6 py-4 rounded-t-lg">
        {t("Step 3: Pre-Job Planning & Training")}
      </div>

      <div className="p-6">
        <div className="bg-white rounded-lg shadow-md p-0">
          <div className="bg-gray-800 flex text-white text-lg font-inter px-6 py-4 rounded-t-lg">
            {t("SECTION 2: Pre-Job Planning & Training")}
          </div>

          <div className="p-6 grid grid-cols-1 md:grid-cols-1 gap-6">
            {[
              "Daily safety meetings Conducted",
              "DJSA/CJSA completed and reviewed",
              "Task-specific hazards/controls documented",
              "Permits (Client/NTACT) in place",
              "Operations have valid training cards",
              "Monthly safety training held",
              "Site orientation completed",
            ].map((question, index) => {
              const isGrayBackground =
                question === "DJSA/CJSA completed and reviewed" ||
                question === "Permits (Client/NTACT) in place" ||
                question === "Monthly safety training held";

              return (
                <div
                  key={index}
                  className={`border rounded-md p-4 flex flex-col justify-between h-auto ${
                    isGrayBackground ? "bg-gray-100" : "bg-white"
                  }`}
                >
                  <div className="text-gray-800 font-medium mb-4 text-left w-full">
                    {`2.${index + 1}. ${t(question)}`}
                  </div>
                  <hr className="border-t border-gray-300 mb-4" />

                  <div className="flex justify-center space-x-8">
                    {/* YES Option */}
                    <label className="flex items-center text-green-500 text-sm font-inter cursor-pointer">
                      <input
                        type="radio"
                        name={`q2-${index}`}
                        value="YES"
                        checked={formData.preJob[index]?.answer === "YES"}
                        onChange={() => handleRadioChange("preJob", index, "YES")}
                        className="mb-1 mr-1"
                      />
                      <span className="mb-[5px]">{t("YES")}</span>
                    </label>

                    {/* NO Option */}
                    <label className="flex items-center text-red-500 text-sm font-inter cursor-pointer">
                      <input
                        type="radio"
                        name={`q2-${index}`}
                        value="NO"
                        checked={formData.preJob[index]?.answer === "NO"}
                        onChange={() => handleRadioChange("preJob", index, "NO")}
                        className="mb-1 mr-1"
                      />
                      <span className="mb-[5px]">{t("NO")}</span>
                    </label>

                    {/* N/A Option */}
                    <label className="flex items-center text-gray-500 text-sm font-inter cursor-pointer">
                      <input
                        type="radio"
                        name={`q2-${index}`}
                        value="N/A"
                        checked={formData.preJob[index]?.answer === "N/A"}
                        onChange={() => handleRadioChange("preJob", index, "N/A")}
                        className="mb-1 mr-1"
                      />
                      <span className="mb-[5px]">N/A</span>
                    </label>
                    
                  </div>
                  {/* ✅ Show comment & image preview if NO is selected */}
{formData.preJob[index]?.answer === "NO" &&
  (formData.preJob[index]?.comment ||
    (formData.preJob[index]?.images?.length > 0 ||
      formData.preJob[index]?.localpreviews?.length > 0)) && (
    <div className="mt-4 text-start border-t pt-3 text-sm text-gray-700">
      {/* 🟢 Comment Section */}
      {formData.preJob[index]?.comment && (
        <p className="mb-2 italic text-gray-800">
          <strong>Comment:</strong> {formData.preJob[index].comment}
        </p>
      )}

      {/* 🟢 Image Previews (Uploaded + Local) */}
      {(formData.preJob[index]?.images?.length > 0 ||
        formData.preJob[index]?.localpreviews?.length > 0) && (
        <div className="grid grid-cols-3 sm:grid-cols-4 gap-3 mt-2">
      {/* SHOW IMAGES ONLY IF ANY EXIST */}
{(formData.preJob[index]?.localpreviews?.length > 0 ||
  formData.preJob[index]?.images?.length > 0) && (
  <div className="grid grid-cols-3 sm:grid-cols-4 gap-3 mt-2">

    {/* 1️⃣ SHOW LOCAL PREVIEWS */}
    {(formData.preJob[index]?.localpreviews || []).map((url, i) => (
      <div key={`local-${i}`} className="relative group">
        <img
          src={url}
          alt={`Local preview ${i + 1}`}
          className="w-24 h-24 object-cover rounded-md border"
        />

        <button
          onClick={() =>
            setFormData((prev) => {
              const updated = { ...prev, preJob: [...prev.preJob] };
              const target = { ...updated.preJob[index] };

              target.localpreviews = target.localpreviews.filter(
                (_, idx) => idx !== i
              );

              updated.preJob[index] = target;
              return updated;
            })
          }
          className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-1 text-xs hover:bg-black/80 opacity-0 group-hover:opacity-100 transition"
        >
          ✕
        </button>
      </div>
    ))}

    {/* 2️⃣ SHOW BACKEND IMAGES ONLY IF NO LOCAL PREVIEWS */}
    {formData.preJob[index]?.localpreviews?.length === 0 &&
      (formData.preJob[index]?.images || []).map((img, i) => (
        <div key={`img-${i}`} className="relative group">
          <img
            src={`https://hub2.ntactops.com/ntact/files/forms_files/${img.file_name}`}
            alt={`Backend image ${i + 1}`}
            className="w-24 h-24 object-cover rounded-md border"
          />

          <button
            onClick={() =>
              setFormData((prev) => {
                const updated = { ...prev, preJob: [...prev.preJob] };
                const target = { ...updated.preJob[index] };

                target.images = target.images.filter((_, idx) => idx !== i);

                updated.preJob[index] = target;
                return updated;
              })
            }
            className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-1 text-xs hover:bg-black/80 opacity-0 group-hover:opacity-100 transition"
          >
            ✕
          </button>
        </div>
      ))}
  </div>
)}

         
        </div>
      )}
    </div>
  )}


                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  </>
)}

  {currentPage === 4 && (
  <>
    <div className="bg-gray-100 rounded-lg shadow-md p-0 mb-6">
      <div className="bg-black flex text-white text-lg font-inter px-6 py-4 rounded-t-lg">
        {t("Step 4: Site Safety and Postings")}
      </div>

      <div className="p-6">
        <div className="bg-white rounded-lg shadow-md p-0">
          <div className="bg-gray-800 flex text-white text-lg font-inter px-6 py-4 rounded-t-lg">
            {t("SECTION 3: Site Postings and Safety Info")}
          </div>

          <div className="p-6 grid grid-cols-1 md:grid-cols-1 gap-6">
            {[
              "Emergency contacts posted",
              "First aid signage visible",
              "Labour law Posters (5-in-1, OSHA log, etc.)",
              "One Call ticket for excavation",
              "Safety alerts posted",
            ].map((question, index) => {
              const isGrayBackground =
                question === "First aid signage visible" ||
                question === "One Call ticket for excavation";

              return (
                <div
                  key={index}
                  className={`border rounded-md p-4 flex flex-col justify-between min-h-[115px] ${
                    isGrayBackground ? "bg-gray-100" : "bg-white"
                  }`}
                >
                  <div className="text-gray-800 font-medium mb-4 text-left w-full">
                    3.{`${index + 1}. ${t(question)}`}
                  </div>

                  <hr className="border-t border-gray-300 mb-4" />

                  <div className="flex justify-center space-x-8">
                    <label className="flex items-center text-green-500 text-sm font-inter cursor-pointer">
                      <input
                        type="radio"
                        name={`q3-${index}`}
                        value="YES"
                        checked={formData.siteSafety[index]?.answer === "YES"}
                        onChange={() => handleRadioChange("siteSafety", index, "YES")}
                        className="mb-1 mr-1"
                      />
                      <span className="mb-[5px]">{t("YES")}</span>
                    </label>

                    <label className="flex items-center text-red-500 text-sm font-inter cursor-pointer">
                      <input
                        type="radio"
                        name={`q3-${index}`}
                        value="NO"
                        checked={formData.siteSafety[index]?.answer === "NO"}
                        onChange={() => handleRadioChange("siteSafety", index, "NO")}
                        className="mb-1 mr-1"
                      />
                      <span className="mb-[5px]">{t("NO")}</span>
                    </label>

                    <label className="flex items-center text-gray-500 text-sm font-inter cursor-pointer">
                      <input
                        type="radio"
                        name={`q3-${index}`}
                        value="N/A"
                        checked={formData.siteSafety[index]?.answer === "N/A"}
                        onChange={() => handleRadioChange("siteSafety", index, "N/A")}
                        className="mb-1 mr-1"
                      />
                      <span className="mb-[5px]">N/A</span>
                    </label>
     

                  </div>{formData.siteSafety[index]?.answer === "NO" &&
  (formData.siteSafety[index]?.comment ||
    formData.siteSafety[index]?.images?.length > 0 ||
    formData.siteSafety[index]?.localpreviews?.length > 0) && (
    <div className="mt-4 text-start border-t pt-3 text-sm text-gray-700">
      {/* 🟢 Show Comment */}
      {formData.siteSafety[index]?.comment && (
        <p className="mb-2 italic text-gray-800">
          <strong>Comment:</strong> {formData.siteSafety[index].comment}
        </p>
      )}

      {/* 🟢 Show Multiple Uploaded Images / Local Previews */}
  {(formData.siteSafety[index]?.images?.length > 0 ||
  formData.siteSafety[index]?.localpreviews?.length > 0) && (
  <div className="grid grid-cols-3 sm:grid-cols-4 gap-3 mt-2">

    {/* 1️⃣ LOCAL PREVIEWS */}
    {(formData.siteSafety[index]?.localpreviews || []).map((url, i) => (
      <div key={`local-${i}`} className="relative group">
        <img
          src={url}
          alt={`Local preview ${i + 1}`}
          className="w-24 h-24 object-cover rounded-md border"
        />

        <button
          onClick={() =>
            setFormData((prev) => {
              const updated = { ...prev, siteSafety: [...prev.siteSafety] };
              const target = { ...updated.siteSafety[index] };

              // Remove ONLY the local preview
              target.localpreviews = target.localpreviews.filter(
                (_, idx) => idx !== i
              );

              updated.siteSafety[index] = target;
              return updated;
            })
          }
          className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-1 text-xs hover:bg-black/80 opacity-0 group-hover:opacity-100 transition"
        >
          ✕
        </button>
      </div>
    ))}

    {/* 2️⃣ BACKEND IMAGES – ONLY WHEN NO LOCAL IMAGES */}
    {formData.siteSafety[index]?.localpreviews?.length === 0 &&
      (formData.siteSafety[index]?.images || []).map((img, i) => (
        <div key={`img-${i}`} className="relative group">
          <img
            src={`https://hub2.ntactops.com/ntact/files/forms_files/${img.file_name}`}
            alt={`Uploaded image ${i + 1}`}
            className="w-24 h-24 object-cover rounded-md border"
          />

          <button
            onClick={() =>
              setFormData((prev) => {
                const updated = { ...prev, siteSafety: [...prev.siteSafety] };
                const target = { ...updated.siteSafety[index] };

                // Remove backend image only
                target.images = target.images.filter((_, idx) => idx !== i);

                updated.siteSafety[index] = target;
                return updated;
              })
            }
            className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-1 text-xs hover:bg-black/80 opacity-0 group-hover:opacity-100 transition"
          >
            ✕
          </button>
        </div>
      ))}
  </div>
)}

    </div>
  )}

                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  </>
)}

 {currentPage === 5 && (
  <>
    <div className="bg-gray-100 rounded-lg shadow-md p-0 mb-6">
      <div className="bg-black flex text-white text-lg font-inter px-6 py-4 rounded-t-lg">
        {t("Step 5: Work Environment & Heights")}
      </div>

      <div className="p-6">
        {/* SECTION 4: WORK ENVIRONMENT */}
        <div className="bg-white rounded-lg shadow-md p-0 mb-6">
          <div className="bg-gray-800 flex text-white text-lg font-inter px-6 py-4 rounded-t-lg">
            {t("SECTION 4: General Site Safety")}
          </div>

          <div className="p-6 grid grid-cols-1 md:grid-cols-1 gap-6">
            {[
              "Smoking areas marked, with extinguisher",
              "Equipment operated by certified personnel",
              "Equipment inspections documented",
              "Equipment safely parked & attachments secured",
              "H2S monitors calibrated and worn properly",
              "First aid kits stocked, accessible",
              "Water & sanitation facilities provided",
              "Housekeeping maintained",
            ].map((question, index) => {
              const isGrayBackground =
                question === "Equipment operated by certified personnel" ||
                question === "Equipment safely parked & attachments secured" ||
                question === "First aid kits stocked, accessible" ||
                question === "Housekeeping maintained";

              return (
                <div
                  key={index}
                  className={`border rounded-md p-4 flex flex-col justify-between min-h-[115px] ${
                    isGrayBackground ? "bg-gray-100" : "bg-white"
                  }`}
                >
                  <div className="text-gray-800 font-medium mb-4 text-left w-full">
                    4.{`${index + 1}. ${t(question)}`}
                  </div>
                  <hr className="border-t border-gray-300 mb-4" />

                  <div className="flex justify-center space-x-8">
                    <label className="flex items-center text-green-500 text-sm font-inter cursor-pointer">
                      <input
                        type="radio"
                        name={`q4-${index}`}
                        value="YES"
                        checked={formData.workEnvironment[index]?.answer === "YES"}
                        onChange={() => handleRadioChange("workEnvironment", index, "YES")}
                        className="mb-1 mr-1"
                      />
                      <span className="mb-[5px]">{t("YES")}</span>
                    </label>

                    <label className="flex items-center text-red-500 text-sm font-inter cursor-pointer">
                      <input
                        type="radio"
                        name={`q4-${index}`}
                        value="NO"
                        checked={formData.workEnvironment[index]?.answer === "NO"}
                        onChange={() => handleRadioChange("workEnvironment", index, "NO")}
                        className="mb-1 mr-1"
                      />
                      <span className="mb-[5px]">{t("NO")}</span>
                    </label>

                    <label className="flex items-center text-gray-500 text-sm font-inter cursor-pointer">
                      <input
                        type="radio"
                        name={`q4-${index}`}
                        value="N/A"
                        checked={formData.workEnvironment[index]?.answer === "N/A"}
                        onChange={() => handleRadioChange("workEnvironment", index, "N/A")}
                        className="mb-1 mr-1"
                      />
                      <span className="mb-[5px]">N/A</span>
                    </label>
                  </div>
                {formData.workEnvironment[index]?.answer === "NO" &&
  (formData.workEnvironment[index]?.comment ||
    formData.workEnvironment[index]?.images?.length > 0 ||
    formData.workEnvironment[index]?.localpreviews?.length > 0) && (
    <div className="mt-4 text-start border-t pt-3 text-sm text-gray-700">
      {/* 🟢 Show Comment */}
      {formData.workEnvironment[index]?.comment && (
        <p className="mb-2 italic text-gray-800">
          <strong>Comment:</strong> {formData.workEnvironment[index].comment}
        </p>
      )}

 {(formData.workEnvironment[index]?.images?.length > 0 ||
  formData.workEnvironment[index]?.localpreviews?.length > 0) && (
  <div className="grid grid-cols-3 sm:grid-cols-4 gap-3 mt-2">

    {/* 1️⃣ LOCAL PREVIEWS */}
    {(formData.workEnvironment[index]?.localpreviews || []).map((url, i) => (
      <div key={`local-${i}`} className="relative group">
        <img
          src={url}
          alt={`Local preview ${i + 1}`}
          className="w-24 h-24 object-cover rounded-md border"
        />

        <button
          onClick={() =>
            setFormData((prev) => {
              const updated = { ...prev, workEnvironment: [...prev.workEnvironment] };
              const target = { ...updated.workEnvironment[index] };

              // Remove ONLY the local preview
              target.localpreviews = target.localpreviews.filter(
                (_, idx) => idx !== i
              );

              updated.workEnvironment[index] = target;
              return updated;
            })
          }
          className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-1 text-xs hover:bg-black/80 opacity-0 group-hover:opacity-100 transition"
        >
          ✕
        </button>
      </div>
    ))}

    {/* 2️⃣ BACKEND IMAGES — ONLY IF NO LOCAL PREVIEWS */}
    {formData.workEnvironment[index]?.localpreviews?.length === 0 &&
      (formData.workEnvironment[index]?.images || []).map((img, i) => (
        <div key={`img-${i}`} className="relative group">
          <img
            src={`https://hub2.ntactops.com/ntact/files/forms_files/${img.file_name}`}
            alt={`Work environment image ${i + 1}`}
            className="w-24 h-24 object-cover rounded-md border"
          />

          <button
            onClick={() =>
              setFormData((prev) => {
                const updated = { ...prev, workEnvironment: [...prev.workEnvironment] };
                const target = { ...updated.workEnvironment[index] };

                // Remove ONLY backend image
                target.images = target.images.filter((_, idx) => idx !== i);

                updated.workEnvironment[index] = target;
                return updated;
              })
            }
            className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-1 text-xs hover:bg-black/80 opacity-0 group-hover:opacity-100 transition"
          >
            ✕
          </button>
        </div>
      ))}
  </div>
)}

    </div>
  )}


                </div>
              );
            })}
          </div>
        </div>

        {/* SECTION 5: WORKING AT HEIGHTS */}
        <div className="bg-white rounded-lg shadow-md p-0">
          <div className="bg-gray-800 flex text-white text-lg font-inter px-6 py-4 rounded-t-lg">
            {t("SECTION 5: Working at Heights")}
          </div>

          <div className="p-6 grid grid-cols-1 md:grid-cols-1 gap-6">
            {[
              "Fall protection used over 6'",
              "Ladders/scaffolds inspected, secured, labeled",
              "Tools/materials secured in elevated work (Drops Program)",
              "Overhead protection to workers when overhead hazards exist",
              "Open holes marked and covered",
            ].map((question, index) => (
              <div
                key={index}
                className="border rounded-md p-4 flex flex-col justify-between min-h-[115px] bg-white"
              >
                <div className="text-gray-800 font-medium mb-4 text-left w-full">
                  {`5.${index + 1}. ${t(question)}`}
                </div>
                <hr className="border-t border-gray-300 mb-4" />

                <div className="flex justify-center space-x-8">
                  <label className="flex items-center text-green-500 text-sm font-inter cursor-pointer">
                    <input
                      type="radio"
                      name={`q5-${index}`}
                      value="YES"
                      checked={formData.workingAtHeights[index]?.answer === "YES"}
                      onChange={() => handleRadioChange("workingAtHeights", index, "YES")}
                      className="mb-1 mr-1"
                    />
                    <span className="mb-[5px]">{t("YES")}</span>
                  </label>

                  <label className="flex items-center text-red-500 text-sm font-inter cursor-pointer">
                    <input
                      type="radio"
                      name={`q5-${index}`}
                      value="NO"
                      checked={formData.workingAtHeights[index]?.answer === "NO"}
                      onChange={() => handleRadioChange("workingAtHeights", index, "NO")}
                      className="mb-1 mr-1"
                    />
                    <span className="mb-[5px]">{t("NO")}</span>
                  </label>

                  <label className="flex items-center text-gray-500 text-sm font-inter cursor-pointer">
                    <input
                      type="radio"
                      name={`q5-${index}`}
                      value="N/A"
                      checked={formData.workingAtHeights[index]?.answer === "N/A"}
                      onChange={() => handleRadioChange("workingAtHeights", index, "N/A")}
                      className="mb-1 mr-1"
                    />
                    <span className="mb-[5px]">N/A</span>
                  </label>
                </div>
            {formData.workingAtHeights[index]?.answer === "NO" &&
  (formData.workingAtHeights[index]?.comment ||
    formData.workingAtHeights[index]?.images?.length > 0 ||
    formData.workingAtHeights[index]?.localpreviews?.length > 0) && (
    <div className="mt-4 text-start border-t pt-3 text-sm text-gray-700">
      {/* 🟢 Show Comment */}
      {formData.workingAtHeights[index]?.comment && (
        <p className="mb-2 italic text-gray-800">
          <strong>Comment:</strong> {formData.workingAtHeights[index].comment}
        </p>
      )}

      {/* 🟢 Show Multiple Uploaded Images / Local Previews */}
   {(formData.workingAtHeights[index]?.images?.length > 0 ||
  formData.workingAtHeights[index]?.localpreviews?.length > 0) && (
  <div className="grid grid-cols-3 sm:grid-cols-4 gap-3 mt-2">

    {/* 1️⃣ LOCAL PREVIEWS */}
    {(formData.workingAtHeights[index]?.localpreviews || []).map((url, i) => (
      <div key={`local-${i}`} className="relative group">
        <img
          src={url}
          alt={`Local preview ${i + 1}`}
          className="w-24 h-24 object-cover rounded-md border"
        />

        <button
          onClick={() =>
            setFormData((prev) => {
              const updated = {
                ...prev,
                workingAtHeights: [...prev.workingAtHeights],
              };

              const target = { ...updated.workingAtHeights[index] };

              // Remove ONLY the local preview
              target.localpreviews = target.localpreviews.filter(
                (_, idx) => idx !== i
              );

              updated.workingAtHeights[index] = target;
              return updated;
            })
          }
          className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-1 text-xs hover:bg-black/80 opacity-0 group-hover:opacity-100 transition"
        >
          ✕
        </button>
      </div>
    ))}

    {/* 2️⃣ BACKEND IMAGES — ONLY IF NO LOCAL PREVIEWS */}
    {formData.workingAtHeights[index]?.localpreviews?.length === 0 &&
      (formData.workingAtHeights[index]?.images || []).map((img, i) => (
        <div key={`img-${i}`} className="relative group">
          <img
            src={`https://hub2.ntactops.com/ntact/files/forms_files/${img.file_name}`}
            alt={`Uploaded image ${i + 1}`}
            className="w-24 h-24 object-cover rounded-md border"
          />

          <button
            onClick={() =>
              setFormData((prev) => {
                const updated = {
                  ...prev,
                  workingAtHeights: [...prev.workingAtHeights],
                };

                const target = { ...updated.workingAtHeights[index] };

                // Remove ONLY backend image
                target.images = target.images.filter((_, idx) => idx !== i);

                updated.workingAtHeights[index] = target;
                return updated;
              })
            }
            className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-1 text-xs hover:bg-black/80 opacity-0 group-hover:opacity-100 transition"
          >
            ✕
          </button>
        </div>
      ))}

  </div>
)}

    </div>
  )}

              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </>
)}


      {currentPage === 6 && (
        <>
          <div className="bg-gray-100 rounded-lg shadow-md p-0 mb-6">
            <div className="bg-black flex text-white text-lg font-inter px-6 py-4 rounded-t-lg">
            {t("Step 6: Tools & Equipment Safety")}
            </div>
            <div className="p-6">
              <div className="bg-white rounded-lg shadow-md p-0">
                <div className="bg-gray-800 flex text-white text-lg font-inter px-6 py-4 rounded-t-lg">
                {t("SECTION 6: Tools, Electrical & Fire Safety")}
                </div>
                <div className="p-6 grid grid-cols-1 md:grid-cols-1 gap-6">
                  {[
                    "GFCIs used and tested",
                    "Cords protected and grounded",
                    "Tools inspected, color coded",
                    "Fire extinguishers available & inspected",
                    "Flammable materials handled per safety protocols",
                  ].map((question, index) => {
                    const isGrayBackground =
                      question === "Cords protected and grounded" ||
                      question === "Fire extinguishers available & inspected";

                    return (
                      <div
                        key={index}
                        className={`border rounded-md p-4 flex flex-col justify-between min-h-[115px] ${
                          isGrayBackground ? "bg-gray-100" : "bg-white"
                        }`}
                      >
                        <div className="text-gray-800 font-medium mb-4 text-left w-full">
                          6.{`${index + 1}. ${t(question)}`}
                        </div>
                        <hr className="border-t border-gray-300 mb-4" />
                        <div className="flex justify-center space-x-8">
                          <label className="flex items-center text-green-500  text-sm font-inter cursor-pointer">
                            <input
                              type="radio"
                              name={`q${index}`}
                              value="YES"
                              checked={formData.toolsElectrical[index]?.answer === "YES"}
                              onChange={() => handleRadioChange("toolsElectrical", index, "YES")}
                              className="mb-1 mr-1"
                            />
                            <span className="mb-[5px]">{t("YES")}</span>
                          </label>
                          <label className="flex items-center text-red-500  text-sm font-inter cursor-pointer">
                            <input
                              type="radio"
                              name={`q${index}`}
                              value="NO"
                              checked={formData.toolsElectrical[index]?.answer === "NO"}
                              onChange={() => handleRadioChange("toolsElectrical", index, "NO")}
                              className="mb-1 mr-1"
                            />
                            <span className="mb-[5px]">NO</span>
                          </label>
                          <label className="flex items-center text-gray-500  text-sm font-inter cursor-pointer">
                            <input
                              type="radio"
                              name={`q${index}`}
                              value="N/A"
                              checked={formData.toolsElectrical[index]?.answer === "N/A"}
                              onChange={() => handleRadioChange("toolsElectrical", index, "N/A")}
                              className="mb-1 mr-1"
                            />
                            <span className="mb-[5px]">N/A</span>
                          </label>
                        </div>
      {formData.toolsElectrical[index]?.answer === "NO" &&
  (formData.toolsElectrical[index]?.comment ||
    formData.toolsElectrical[index]?.images?.length > 0 ||
    formData.toolsElectrical[index]?.localpreviews?.length > 0) && (
    <div className="mt-4 text-start border-t pt-3 text-sm text-gray-700">
      {/* 🟢 Show Comment */}
      {formData.toolsElectrical[index]?.comment && (
        <p className="mb-2 italic text-gray-800">
          <strong>Comment:</strong> {formData.toolsElectrical[index].comment}
        </p>
      )}
{(formData.toolsElectrical[index]?.images?.length > 0 ||
  formData.toolsElectrical[index]?.localpreviews?.length > 0) && (
  <div className="grid grid-cols-3 sm:grid-cols-4 gap-3 mt-2">

    {/* 1️⃣ LOCAL PREVIEWS */}
    {(formData.toolsElectrical[index]?.localpreviews || []).map((url, i) => (
      <div key={`local-${i}`} className="relative group">
        <img
          src={url}
          alt={`Local preview ${i + 1}`}
          className="w-24 h-24 object-cover rounded-md border"
        />

        <button
          onClick={() =>
            setFormData((prev) => {
              const updated = {
                ...prev,
                toolsElectrical: [...prev.toolsElectrical],
              };

              const target = { ...updated.toolsElectrical[index] };

              // Remove ONLY local preview
              target.localpreviews = target.localpreviews.filter(
                (_, idx) => idx !== i
              );

              updated.toolsElectrical[index] = target;
              return updated;
            })
          }
          className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-1 text-xs hover:bg-black/80 opacity-0 group-hover:opacity-100 transition"
        >
          ✕
        </button>
      </div>
    ))}

    {/* 2️⃣ BACKEND IMAGES — ONLY IF NO LOCAL PREVIEWS */}
    {formData.toolsElectrical[index]?.localpreviews?.length === 0 &&
      (formData.toolsElectrical[index]?.images || []).map((img, i) => (
        <div key={`img-${i}`} className="relative group">
          <img
            src={`https://hub2.ntactops.com/ntact/files/forms_files/${img.file_name}`}
            alt={`Uploaded image ${i + 1}`}
            className="w-24 h-24 object-cover rounded-md border"
          />

          <button
            onClick={() =>
              setFormData((prev) => {
                const updated = {
                  ...prev,
                  toolsElectrical: [...prev.toolsElectrical],
                };

                const target = { ...updated.toolsElectrical[index] };

                // Remove ONLY backend image
                target.images = target.images.filter((_, idx) => idx !== i);

                updated.toolsElectrical[index] = target;
                return updated;
              })
            }
            className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-1 text-xs hover:bg-black/80 opacity-0 group-hover:opacity-100 transition"
          >
            ✕
          </button>
        </div>
      ))}

  </div>
)}

    </div>
  )}

                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="bg-white rounded-lg shadow-md p-0">
                <div className="bg-gray-800 flex text-white text-lg font-inter px-6 py-4 rounded-t-lg">
                {t("SECTION 7: Welding & Compressed Gas Safety")}
                </div>
                <div className="p-6 grid grid-cols-1 md:grid-cols-1 gap-6">
                  {[
                    "Welding rig inspected",
                    "Fire watch available",
                    "PPE for grinding (double eye protection)",
                    "Compressed gas cylinders secured and labeled",
                    "Hoses in good condition and crimped",
                  ].map((question, index) => (
                    <div
                      key={index}
                      className="border rounded-md p-4 flex flex-col justify-between min-h-[115px] bg-white"
                    >
                      <div className="text-gray-800 font-medium mb-4 text-left w-full">
                        {`7.${index + 1}. ${t(question)}`}
                      </div>
                      <hr className="border-t border-gray-300 mb-4" />
                      <div className="flex justify-center space-x-8">
                        <label className="flex items-center text-green-500  text-sm font-inter cursor-pointer">
                          <input
                            type="radio"
                            name={`q7${index + 1}`}
                            value="YES"
                            checked={formData.weldingGas[index]?.answer === "YES"}
                            onChange={() => handleRadioChange("weldingGas", index, "YES")}
                            className="mb-1 mr-1"
                          />
                          <span className="mb-[5px]">{t("YES")}</span>
                        </label>
                        <label className="flex items-center text-red-500  text-sm font-inter cursor-pointer">
                          <input
                            type="radio"
                            name={`q7${index + 1}`}
                            value="NO"
                            checked={formData.weldingGas[index]?.answer === "NO"}
                            onChange={() => handleRadioChange("weldingGas", index, "NO")}
                            className="mb-1 mr-1"
                          />
                          <span className="mb-[5px]">NO</span>
                        </label>
                        <label className="flex items-center text-gray-500  text-sm font-inter cursor-pointer">
                          <input
                            type="radio"
                            name={`q7${index + 1}`}
                            value="N/A"
                            checked={formData.weldingGas[index]?.answer === "N/A"}
                            onChange={() => handleRadioChange("weldingGas", index, "N/A")}
                            className="mb-1 mr-1"
                          />
                          <span className="mb-[5px]">N/A</span>
                        </label>
                      </div>
                 {formData.weldingGas[index]?.answer === "NO" &&
  (formData.weldingGas[index]?.comment ||
    formData.weldingGas[index]?.images?.length > 0 ||
    formData.weldingGas[index]?.localpreviews?.length > 0) && (
    <div className="mt-4 text-start border-t pt-3 text-sm text-gray-700">
      {/* 🟢 Show Comment */}
      {formData.weldingGas[index]?.comment && (
        <p className="mb-2 italic text-gray-800">
          <strong>Comment:</strong> {formData.weldingGas[index].comment}
        </p>
      )}
{(formData.weldingGas[index]?.images?.length > 0 ||
  formData.weldingGas[index]?.localpreviews?.length > 0) && (
  <div className="grid grid-cols-3 sm:grid-cols-4 gap-3 mt-2">

    {/* 1️⃣ LOCAL PREVIEWS */}
    {(formData.weldingGas[index]?.localpreviews || []).map((url, i) => (
      <div key={`local-${i}`} className="relative group">
        <img
          src={url}
          alt={`Local preview ${i + 1}`}
          className="w-24 h-24 object-cover rounded-md border"
        />

        <button
          onClick={() =>
            setFormData((prev) => {
              const updated = {
                ...prev,
                weldingGas: [...prev.weldingGas],
              };

              const target = { ...updated.weldingGas[index] };

              // Remove ONLY local preview
              target.localpreviews = target.localpreviews.filter(
                (_, idx) => idx !== i
              );

              updated.weldingGas[index] = target;
              return updated;
            })
          }
          className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-1 text-xs hover:bg-black/80 opacity-0 group-hover:opacity-100 transition"
        >
          ✕
        </button>
      </div>
    ))}

    {/* 2️⃣ BACKEND IMAGES — ONLY IF NO LOCAL PREVIEWS */}
    {formData.weldingGas[index]?.localpreviews?.length === 0 &&
      (formData.weldingGas[index]?.images || []).map((img, i) => (
        <div key={`img-${i}`} className="relative group">
          <img
            src={`https://hub2.ntactops.com/ntact/files/forms_files/${img.file_name}`}
            alt={`Uploaded image ${i + 1}`}
            className="w-24 h-24 object-cover rounded-md border"
          />

          <button
            onClick={() =>
              setFormData((prev) => {
                const updated = {
                  ...prev,
                  weldingGas: [...prev.weldingGas],
                };

                const target = { ...updated.weldingGas[index] };

                // Remove ONLY backend image
                target.images = target.images.filter((_, idx) => idx !== i);

                updated.weldingGas[index] = target;
                return updated;
              })
            }
            className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-1 text-xs hover:bg-black/80 opacity-0 group-hover:opacity-100 transition"
          >
            ✕
          </button>
        </div>
      ))}

  </div>
)}

    </div>
  )}


                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {currentPage === 7 && (
        <>
          <div className="bg-gray-100 rounded-lg shadow-md p-0 mb-6">
            <div className="bg-black flex text-white text-lg font-inter px-6 py-4 rounded-t-lg">
            {t("Step 7: Excavation, Subcontractor & Action Plan")}
            </div>
            <div className="p-6">
              <div className="bg-white rounded-lg shadow-md p-0">
                <div className="bg-gray-800 flex text-white text-lg font-inter px-6 py-4 rounded-t-lg">
                {t("SECTION 8: Excavation Safety")}
                </div>
                <div className="p-6 grid grid-cols-1 md:grid-cols-1 gap-6">
                  {[
                    "One Call completed",
                    "Excavations barricaded & dry",
                    "Access ladders/ramps every 25'",
                    "Proper shoring/sloping for 5'+",
                    "Utilities marked",
                  ].map((question, index) => {
                    const isGrayBackground =
                      question === "Excavations barricaded & dry" ||
                      question === "Proper shoring/sloping for 5'+";

                    return (
                      <div
                        key={index}
                        className={`border rounded-md p-4 flex flex-col justify-between min-h-[115px] ${
                          isGrayBackground ? "bg-gray-100" : "bg-white"
                        }`}
                      >
                        <div className="text-gray-800 font-medium mb-4 text-left w-full">
                          8.{`${index + 1}. ${t(question)}`}
                        </div>
                        <hr className="border-t border-gray-300 mb-4" />
                        <div className="flex justify-center space-x-8">
                          <label className="flex items-center text-green-500  text-sm font-inter cursor-pointer">
                            <input
                              type="radio"
                              name={`q${index}`}
                              value="YES"
                              checked={formData.excavation[index]?.answer === "YES"}
                              onChange={() => handleRadioChange("excavation", index, "YES")}
                              className="mb-1 mr-1"
                            />
                            <span className="mb-[5px]">{t("YES")}</span>
                          </label>
                          <label className="flex items-center text-red-500  text-sm font-inter cursor-pointer">
                            <input
                              type="radio"
                              name={`q${index}`}
                              value="NO"
                              checked={formData.excavation[index]?.answer === "NO"}
                              onChange={() => handleRadioChange("excavation", index, "NO")}
                              className="mb-1 mr-1"
                            />
                            <span className="mb-[5px]">NO</span>
                          </label>
                          <label className="flex items-center text-gray-500  text-sm font-inter cursor-pointer">
                            <input
                              type="radio"
                              name={`q${index}`}
                              value="N/A"
                              checked={formData.excavation[index]?.answer === "N/A"}
                              onChange={() => handleRadioChange("excavation", index, "N/A")}
                              className="mb-1 mr-1"
                            />
                            <span className="mb-[5px]">N/A</span>
                          </label>
                        </div>
                      {formData.excavation[index]?.answer === "NO" &&
  (formData.excavation[index]?.comment ||
    formData.excavation[index]?.images?.length > 0 ||
    formData.excavation[index]?.localpreviews?.length > 0) && (
    <div className="mt-4 text-start border-t pt-3 text-sm text-gray-700">
      {/* 🟢 Show Comment */}
      {formData.excavation[index]?.comment && (
        <p className="mb-2 italic text-gray-800">
          <strong>Comment:</strong> {formData.excavation[index].comment}
        </p>
      )}

      {/* 🟢 Show Multiple Uploaded Images / Local Previews */}
    {/* 🟢 Show Multiple Uploaded Images / Local Previews */}
{(formData.excavation[index]?.images?.length > 0 ||
  formData.excavation[index]?.localpreviews?.length > 0) && (
  <div className="grid grid-cols-3 sm:grid-cols-4 gap-3 mt-2">

    {/* 1️⃣ LOCAL PREVIEWS */}
    {(formData.excavation[index]?.localpreviews || []).map((url, i) => (
      <div key={`local-${i}`} className="relative group">
        <img
          src={url}
          alt={`Local preview ${i + 1}`}
          className="w-24 h-24 object-cover rounded-md border"
        />

        <button
          onClick={() =>
            setFormData((prev) => {
              const updated = {
                ...prev,
                excavation: [...prev.excavation],
              };

              const target = { ...updated.excavation[index] };

              // 🧹 Remove ONLY the selected local preview
              target.localpreviews = target.localpreviews.filter(
                (_, idx) => idx !== i
              );

              updated.excavation[index] = target;
              return updated;
            })
          }
          className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-1 text-xs hover:bg-black/80 opacity-0 group-hover:opacity-100 transition"
        >
          ✕
        </button>
      </div>
    ))}

    {/* 2️⃣ BACKEND IMAGES — ONLY WHEN NO LOCAL IMAGES */}
    {formData.excavation[index]?.localpreviews?.length === 0 &&
      (formData.excavation[index]?.images || []).map((img, i) => (
        <div key={`img-${i}`} className="relative group">
          <img
            src={`https://hub2.ntactops.com/ntact/files/forms_files/${img.file_name}`}
            alt={`Uploaded image ${i + 1}`}
            className="w-24 h-24 object-cover rounded-md border"
          />

          <button
            onClick={() =>
              setFormData((prev) => {
                const updated = {
                  ...prev,
                  excavation: [...prev.excavation],
                };

                const target = { ...updated.excavation[index] };

                // 🧹 Remove ONLY the selected backend image
                target.images = target.images.filter((_, idx) => idx !== i);

                updated.excavation[index] = target;
                return updated;
              })
            }
            className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-1 text-xs hover:bg-black/80 opacity-0 group-hover:opacity-100 transition"
          >
            ✕
          </button>
        </div>
      ))}

  </div>
)}

    </div>
  )}


                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="bg-white rounded-lg shadow-md p-0">
                <div className="bg-gray-800 flex text-white text-lg font-inter px-6 py-4 rounded-t-lg">
                {t("SECTION 9: Subcontractor Safety")}
                </div>
                <div className="p-6 grid grid-cols-1 md:grid-cols-1 gap-6">
                  {[
                    "JSA's used for tasks",
                    "PPE used correctly",
                    "Training cards on hand",
                    "SIMOPS JSA signed when applicable",
                    "Equipment and First Aid checked",
                  ].map((question, index) => (
                    <div
                      key={index}
                      className="border rounded-md p-4 flex flex-col justify-between min-h-[115px] bg-white"
                    >
                      <div className="text-gray-800 font-medium mb-4 text-left w-full">
                        {`9.${index + 1}. ${t(question)}`}
                      </div>
                      <hr className="border-t border-gray-300 mb-4" />
                      <div className="flex justify-center space-x-8">
                        <label className="flex items-center text-green-500  text-sm font-inter cursor-pointer">
                          <input
                            type="radio"
                            name={`q9${index + 1}`}
                            value="YES"
                            checked={formData.subcontractor[index]?.answer === "YES"}
                            onChange={() => handleRadioChange("subcontractor", index, "YES")}
                            className="mb-1 mr-1"
                          />
                          <span className="mb-[5px]">{t("YES")}</span>
                        </label>
                        <label className="flex items-center text-red-500  text-sm font-inter cursor-pointer">
                          <input
                            type="radio"
                            name={`q9${index + 1}`}
                            value="NO"
                            checked={formData.subcontractor[index]?.answer === "NO"}
                            onChange={() => handleRadioChange("subcontractor", index, "NO")}
                            className="mb-1 mr-1"
                          />
                          <span className="mb-[5px]">NO</span>
                        </label>
                        <label className="flex items-center text-gray-500  text-sm font-inter cursor-pointer">
                          <input
                            type="radio"
                            name={`q9${index + 1}`}
                            value="N/A"
                            checked={formData.subcontractor[index]?.answer === "N/A"}
                            onChange={() => handleRadioChange("subcontractor", index, "N/A")}
                            className="mb-1 mr-1"
                          />
                          <span className="mb-[5px]">N/A</span>
                        </label>
                      </div>
        {formData.subcontractor[index]?.answer === "NO" &&
  (formData.subcontractor[index]?.comment ||
    formData.subcontractor[index]?.images?.length > 0 ||
    formData.subcontractor[index]?.localpreviews?.length > 0) && (
    <div className="mt-4 text-start border-t pt-3 text-sm text-gray-700">
      {/* 🟢 Show Comment */}
      {formData.subcontractor[index]?.comment && (
        <p className="mb-2 italic text-gray-800">
          <strong>Comment:</strong> {formData.subcontractor[index].comment}
        </p>
      )}

      {/* 🟢 Show Multiple Uploaded Images / Local Previews */}
     {(formData.subcontractor[index]?.images?.length > 0 ||
  formData.subcontractor[index]?.localpreviews?.length > 0) && (
  <div className="grid grid-cols-3 sm:grid-cols-4 gap-3 mt-2">

    {/* 1️⃣ LOCAL PREVIEWS */}
    {(formData.subcontractor[index]?.localpreviews || []).map((url, i) => (
      <div key={`sub-local-${i}`} className="relative group">
        <img
          src={url}
          alt={`Subcontractor local preview ${i + 1}`}
          className="w-24 h-24 object-cover rounded-md border"
        />

        <button
          onClick={() =>
            setFormData((prev) => {
              const updated = {
                ...prev,
                subcontractor: [...prev.subcontractor],
              };

              const target = { ...updated.subcontractor[index] };

              // 🧹 Remove ONLY the selected local preview
              target.localpreviews = target.localpreviews.filter(
                (_, idx) => idx !== i
              );

              updated.subcontractor[index] = target;
              return updated;
            })
          }
          className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-1 text-xs hover:bg-black/80 opacity-0 group-hover:opacity-100 transition"
        >
          ✕
        </button>
      </div>
    ))}

    {/* 2️⃣ BACKEND IMAGES — ONLY IF NO LOCAL PREVIEWS */}
    {formData.subcontractor[index]?.localpreviews?.length === 0 &&
      (formData.subcontractor[index]?.images || []).map((img, i) => (
        <div key={`sub-img-${i}`} className="relative group">
          <img
            src={`https://hub2.ntactops.com/ntact/files/forms_files/${img.file_name}`}
            alt={`Subcontractor uploaded image ${i + 1}`}
            className="w-24 h-24 object-cover rounded-md border"
          />

          <button
            onClick={() =>
              setFormData((prev) => {
                const updated = {
                  ...prev,
                  subcontractor: [...prev.subcontractor],
                };

                const target = { ...updated.subcontractor[index] };

                // 🧹 Remove ONLY the selected backend image
                target.images = target.images.filter((_, idx) => idx !== i);

                updated.subcontractor[index] = target;
                return updated;
              })
            }
            className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-1 text-xs hover:bg-black/80 opacity-0 group-hover:opacity-100 transition"
          >
            ✕
          </button>
        </div>
      ))}

  </div>
)}

    </div>
  )}


                    </div>
                  ))}
                </div>
              </div>
              <div className="bg-white rounded-lg shadow-md p-0">
                <div className="bg-gray-800 flex text-white text-lg font-inter px-6 py-4 rounded-t-lg">
                {t("SECTION 10: Emergency Action Plan")}
                </div>
                <div className="p-6 grid grid-cols-1 md:grid-cols-1 gap-6">
                  {[
                    "Is the SSSP plan available and reviewed",
                    "Do employees know what is in the plan",
                    "Do employees know how to react to an emergency",
                    "Is the emergency plan noted on JSA",
                    "Is there a system for accounting everyone onsite",
                  ].map((question, index) => (
                    <div
                      key={index}
                      className="border rounded-md p-4 flex flex-col justify-between min-h-[115px] bg-white"
                    >
                      <div className="text-gray-800 font-medium mb-4 text-left w-full">
                        {`10.${index + 1}. ${t(question)}`}
                      </div>
                      <hr className="border-t border-gray-300 mb-4" />
                      <div className="flex justify-center space-x-8">
                        <label className="flex items-center text-green-500  text-sm font-inter cursor-pointer">
                          <input
                            type="radio"
                            name={`q10${index + 1}`}
                            value="YES"
                            checked={formData.emergencyPlan[index]?.answer === "YES"}
                            onChange={() => handleRadioChange("emergencyPlan", index, "YES")}
                            className="mb-1 mr-1"
                          />
                          <span className="mb-[5px]">{t("YES")}</span>
                        </label>
                        <label className="flex items-center text-red-500  text-sm font-inter cursor-pointer">
                          <input
                            type="radio"
                            name={`q10${index + 1}`}
                            value="NO"
                            checked={formData.emergencyPlan[index]?.answer === "NO"}
                            onChange={() => handleRadioChange("emergencyPlan", index, "NO")}
                            className="mb-1 mr-1"
                          />
                          <span className="mb-[5px]">NO</span>
                        </label>
                        <label className="flex items-center text-gray-500  text-sm font-inter cursor-pointer">
                          <input
                            type="radio"
                            name={`q10${index + 1}`}
                            value="N/A"
                            checked={formData.emergencyPlan[index]?.answer === "N/A"}
                            onChange={() => handleRadioChange("emergencyPlan", index, "N/A")}
                            className="mb-1 mr-1"
                          />
                          <span className="mb-[5px]">N/A</span>
                        </label>
                      </div>

                  {formData.emergencyPlan[index]?.answer === "NO" &&
  (formData.emergencyPlan[index]?.comment ||
    formData.emergencyPlan[index]?.images?.length > 0 ||
    formData.emergencyPlan[index]?.localpreviews?.length > 0) && (
    <div className="mt-4 text-start border-t pt-3 text-sm text-gray-700">
      {/* 🟢 Show Comment */}
      {formData.emergencyPlan[index]?.comment && (
        <p className="mb-2 italic text-gray-800">
          <strong>Comment:</strong> {formData.emergencyPlan[index].comment}
        </p>
      )}

      {/* 🟢 Show Multiple Uploaded Images / Local Previews */}
     {(formData.emergencyPlan[index]?.images?.length > 0 ||
  formData.emergencyPlan[index]?.localpreviews?.length > 0) && (
  <div className="grid grid-cols-3 sm:grid-cols-4 gap-3 mt-2">

    {/* 1️⃣ LOCAL PREVIEWS */}
    {(formData.emergencyPlan[index]?.localpreviews || []).map((url, i) => (
      <div key={`emergency-local-${i}`} className="relative group">
        <img
          src={url}
          alt={`Emergency plan preview ${i + 1}`}
          className="w-24 h-24 object-cover rounded-md border"
        />

        <button
          onClick={() =>
            setFormData((prev) => {
              const updated = {
                ...prev,
                emergencyPlan: [...prev.emergencyPlan],
              };

              const target = { ...updated.emergencyPlan[index] };

              // 🧹 Remove ONLY the local preview
              target.localpreviews = target.localpreviews.filter(
                (_, idx) => idx !== i
              );

              updated.emergencyPlan[index] = target;
              return updated;
            })
          }
          className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-1 text-xs hover:bg-black/80 opacity-0 group-hover:opacity-100 transition"
        >
          ✕
        </button>
      </div>
    ))}

    {/* 2️⃣ BACKEND IMAGES — ONLY IF NO LOCAL IMAGES */}
    {formData.emergencyPlan[index]?.localpreviews?.length === 0 &&
      (formData.emergencyPlan[index]?.images || []).map((img, i) => (
        <div key={`emergency-img-${i}`} className="relative group">
          <img
            src={`https://hub2.ntactops.com/ntact/files/forms_files/${img.file_name}`}
            alt={`Emergency plan uploaded ${i + 1}`}
            className="w-24 h-24 object-cover rounded-md border"
          />

          <button
            onClick={() =>
              setFormData((prev) => {
                const updated = {
                  ...prev,
                  emergencyPlan: [...prev.emergencyPlan],
                };

                const target = { ...updated.emergencyPlan[index] };

                // 🧹 Remove ONLY backend image
                target.images = target.images.filter((_, idx) => idx !== i);

                updated.emergencyPlan[index] = target;
                return updated;
              })
            }
            className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-1 text-xs hover:bg-black/80 opacity-0 group-hover:opacity-100 transition"
          >
            ✕
          </button>
        </div>
      ))}

  </div>
)}

    </div>
  )}

                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {currentPage === 8 && (
        <>
          <div className="bg-white rounded-md shadow-md font-inter overflow-hidden mb-6 mx-4">
            <div className="flex bg-black text-white py-2 px-4 rounded-tr-xl rounded-tl-xl text-lg font-inter">
            {t("Step 8: Infractions & Signatures")}
            </div>
            <div className="bg-white border rounded-md p-4 overflow-hidden mb-6">
              <div className="flex bg-red-600 text-white font-inter p-3 rounded-tr-lg rounded-tl-lg">
                ⚠️ {t("Details of Infractions / Notes")}
              </div>

<div className="bg-white rounded-lg shadow-md p-6 mt-10">
  <div className="flex justify-between items-center mb-4">
    <h2 className="text-lg font-semibold text-gray-800">Uploaded Images Summary</h2>
    <button
      onClick={() => {
        
        setIsGlobalUploadModalOpen(true)
      }}
      className="bg-black text-white px-4 py-2 rounded-md text-sm hover:bg-gray-800 transition"
    >
      Add New Upload
    </button>
  </div>

  {Object.entries(formData).some(([_, arr]) =>
  Array.isArray(arr) && arr.some(item =>
    (item?.images?.length || item?.localpreviews?.length)
  )
) ? (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
    {Object.entries(formData).map(([sectionKey, sectionData]) =>
      Array.isArray(sectionData)
        ? sectionData.map((item, qIdx) => {
            const hasLocal = item?.localpreviews?.length > 0;
            const hasBackend = item?.images?.length > 0;

            if (!hasLocal && !hasBackend) return null;

            return (
              <div
                key={`${sectionKey}-${qIdx}`}
                className="border rounded-lg p-4 bg-gray-50 shadow-sm"
              >
                <h3 className="font-semibold text-gray-800 mb-1 capitalize">
                  {sectionKey.replace(/([A-Z])/g, " $1")}
                </h3>

                <p className="text-sm text-gray-700 mb-3">
                  <strong>Question {qIdx + 1}:</strong>{" "}
                  {sectionQuestions[sectionKey]?.[qIdx] || "N/A"}
                </p>

                <div className="flex flex-wrap gap-2">

                  {/* 🟢 1️⃣ Local Previews */}
                  {(item.localpreviews || []).map((url, i) => (
                    <img
                      key={`local-${i}`}
                      src={url}
                      alt="Preview"
                      className="w-20 h-20 object-cover rounded-md border"
                    />
                  ))}

                  {/* 🔵 2️⃣ Backend Images — only if no local previews */}
                  {(!item.localpreviews?.length &&
                    (item.images || []).map((img, i) => (
                      <img
                        key={`remote-${i}`}
                        src={`https://hub2.ntactops.com/ntact/files/forms_files/${img.file_name}`}
                        alt="Uploaded"
                        className="w-20 h-20 object-cover rounded-md border"
                      />
                    )))}
                </div>
              </div>
            );
          })
        : null
    )}
  </div>
) : (
  <p className="text-gray-500 text-sm">No images uploaded yet.</p>
)}

</div>



            </div>
                 <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-4">
 {formData.auditors.map((auditor, index) => (
  <div key={index} className="flex flex-col">
    <label className="text-sm font-semibold mb-1 text-left">
      {auditor.auditorName}
    </label>
    <input
      type="text"
      placeholder="Enter auditor name"
      onClick={() => {
        type.current = index; // store index for new mapping
        setSignatureModal(true);
      }}
      className="border p-2 rounded w-full"
    />
  </div>
))}
</div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-4">
         

              {/* <div className="flex flex-col">
                <label className="text-sm font-semibold mb-1 text-left">{t("Auditor Signature")}</label>
                <input
                onClick={()=>{
                  type.current='auditor'
                  setSignatureModal(true)
                }}
                  type="text"
                  placeholder="Type your name"
                  // value={formData.auditorSignature}
                  // onChange={(e) => handleInputChange( e,null,"auditorSignature")}
                  className="border p-2 rounded w-full"
                />
              </div> */}
              <div className="flex flex-col">
                <label className="text-sm font-semibold mb-1 text-left">{t("Supervisor Signature")}</label>
                <input
                  type="text"
                  placeholder="Supervisor name"
                   onClick={()=>{
                  type.current='supervisor'
                  setSignatureModal(true)
                }}
                  // value={formData.supervisorSignature}
                  // onChange={(e) => handleInputChange( e,null,"supervisorSignature")}
                  className="border p-2 rounded w-full"
                />
              </div>
              <div className="flex flex-col">
                <label className="text-sm font-semibold font-inter mb-1 text-left">{t("Date")}</label>
                <DatePicker
  selected={formData.signatureDate ? new Date(formData.signatureDate) : null} // Convert string to Date object
  onChange={(date) =>
    handleInputChange(
      { target: { value: date ? date.toISOString().split('T')[0] : '' } },
      null,
      'signatureDate'
    ) // Mimic event object for handleInputChange
  }
  className="border p-2 rounded w-full" // Match original input styling
  wrapperClassName="w-full" // Ensure full width for wrapper
  dateFormat="MM-dd-yyyy" // Display format as MM-dd-yyyy
  maxDate={new Date()} // Disables future dates
  placeholderText="MM-DD-YYYY" // Add placeholder for UX
/>
              </div>
            </div>
 <div className="flex gap-8 items-center p-4 border border-gray-200 rounded-lg bg-gray-50 shadow-sm">
 {formData.auditors.map((auditor, index) => (
  <div
    key={index}
    className="flex gap-8 items-start p-4"
  >
    <div className="flex flex-col items-center p-4 border border-gray-300 rounded-md bg-white shadow-sm w-48">
      <span className="text-sm font-medium text-gray-700 mb-3">
        Auditor {auditor.auditorName} Signature
      </span>

      {/* 1️⃣ NEW UPLOADED SIGNATURE */}
      {auditor.file instanceof File ? (
        <img
          className="w-40 h-24 object-contain border border-gray-300 rounded-md bg-white"
          src={URL.createObjectURL(auditor.file)}
          alt="Auditor Signature"
        />

      ) : auditor.imgurl?.file_name ? (
        /* 2️⃣ EXISTING SERVER SIGNATURE */
        <img
          className="w-40 h-24 object-contain border border-gray-300 rounded-md bg-white"
          src={`https://hub2.ntactops.com/ntact/files/forms_files/${auditor.imgurl.file_name}`}
          alt="Auditor Signature"
        />

      ) : (
        /* 3️⃣ NO SIGNATURE */
        <div className="w-40 h-24 flex items-center justify-center border border-gray-300 rounded-md bg-gray-100 text-gray-400 text-xs">
          No signature
        </div>
      )}
    </div>
  </div>
))}



  {/* Supervisor Signature */}
 <div className="flex flex-col items-center p-4 border border-gray-300 rounded-md bg-white shadow-sm w-48">
  <span className="text-sm font-medium text-gray-700 mb-3">
    Supervisor Signature
  </span>

  {/* 1️⃣ NEW UPLOADED SIGNATURE */}
  {supervisorImage instanceof File ? (
    <img
      className="w-40 h-24 object-contain border border-gray-200 rounded-md bg-white"
      src={URL.createObjectURL(supervisorImage)}
      alt="Supervisor Signature"
      onLoad={(e) => URL.revokeObjectURL(e.target.src)}
    />

  ) : formData.supervisorSignature?.file_name ? (
    /* 2️⃣ EXISTING BACKEND SIGNATURE (Edit Mode) */
    <img
      className="w-40 h-24 object-contain border border-gray-200 rounded-md bg-white"
      src={`https://hub2.ntactops.com/ntact/files/forms_files/${formData.supervisorSignature.file_name}`}
      alt="Supervisor Signature"
    />

  ) : (
    /* 3️⃣ NO SIGNATURE */
    <div className="w-40 h-24 flex items-center justify-center border border-gray-200 rounded-md bg-gray-100 text-gray-400 text-xs">
      No signature
    </div>
  )}
</div>

</div>


          </div>
          <div> <div className="flex flex-col">
                <label className="text-sm font-semibold mb-1 text-left">{t("Additional comment")}</label>
                <textarea
              
                  type="text"
                  placeholder="Additional comment"
                  value={formData.comment}
                  onChange={(e) => handleInputChange( e,null,"comment")}
                  className="border p-2 rounded w-full"
                />
              </div></div>
          <div className="mt-6 bg-gray-100 border-gray-200 border-t overflow-hidden">
            <span className="flex block font-inter bg-gray-100 p-3 text-gray-700">
              <DescriptionIcon className="mr-2" /> {t("Document Information")}
            </span>
            <div className="flex w-full justify-center">
              <div className="flex w-[95%] p-6 rounded-[10px] border mb-4 bg-[white] border-gray-200">
                <div className="w-[50%]">
                  <p className="mb-2 my-0 text-gray-700 flex font-semibold">{t("HEALTH SAFETY & ENVIRONMENTAL")}</p>
                  <p className="font-inter text-xs my-0 text-left">{t("Document Number:")} 18-5-D</p>
                  <p className="font-inter text-xs my-0 text-left">{t("Revision")}: 2</p>
                  <p className="font-inter text-xs my-0 text-left">{t("Date")}:{formData.auditDate}</p>
                </div>
                <div className="flex w-[50%] justify-around items-center">
                  <div className="">
                    <p className="font-inter my-0 text-left">{t("Document Name:")}</p>
                    <p className="text-left text-sm text-gray-600 font-inter">
                    {t("Form Type:")}<br />
                      <span className="text-gray-600 font-inter">{t("Section")}:</span>
                    </p>
                  </div>
                  <div className="flex flex-col mt-6">
                    <p className="text-gray-700 flex text-sm font-semibold">
                    {t("SAFETY AND HEALTH PRIMARY AUDIT FORM")}
                    </p>
                    <p className="text-left font-inter text-sm">HSE-18</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      <div className="flex justify-between mt-8">
        <button
          onClick={goToPreviousPage}
          className="border border-gray-400 text-gray-600 px-8 py-2 rounded-md hover:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed"
          disabled={currentPage === 1}
        >
          ← {t("Previous")}
        </button>
        {currentPage < 8 ? (
          <button
            onClick={goToNextPage}
            className="bg-red-500 text-white px-8 py-2 rounded-md hover:bg-red-600"
          >
           {t("Next")} →
          </button>
        ) : (
          <div onClick={handleSubmit}
            className="bg-green-500 flex items-center text-white px-6 cursor-pointer gap-2 py-2 rounded-md hover:bg-green-600"
          >
            <span className="flex items-center justify-center w-4 h-4 rounded-full border text-white text-green-600">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-3 h-3"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={3}
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </span>
            {t("Submit")}
          </div>
        )}
      </div>
      <SafetyImageCommentModal
  open={isSafetyModalOpen}
  onClose={() => {
  
    setIsSafetyModalOpen(false)}}
  onSubmit={handleModalSubmit}
  loader={loader}
  setSelectedQuestion={()=>{console.log('click')}}
/>
<GlobalUploadModal
  open={isGlobalUploadModalOpen}
  setSelectedSection={setSelectedSection}
  selectedSection={selectedSection}
    setSelectedIndex={setSelectedIndex}
  onClose={() => {
    setIsSafetyModalOpen(false)
    setIsGlobalUploadModalOpen(false)}}
  sectionOptions={Object.keys(sectionQuestions)}
  questionOptions={sectionQuestions}
  onSubmit={handleGlobalUpload}
/>
          <ToastMessage message={alertMessage} severity={severity} open={open} handleClose={handleCloseToast} />
      <SignatureModal isModal={signaturemodal} setModal={setSignatureModal} onSave={HandleSignature} />
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default SafetyHomeInfoForm;
